import React, { Component } from "react";
import {
  GET_IDEA_URL,
  REVIEW_IDEA_URL,
  APPROVED,
  PENDING,
  SENT_BACK,
  REJECTED,
  OTHER_REGIONS,
  DISPLAYPROJECTTHEME,
  GET_METADATA,
  DATA_BRIDGE_CAMPAIGN,
  X_POLLINATION_CAMPAIGN,
  ACCESS_TOKEN,
  USER_DATA,
  YESORNO, SOLUTIONCOMPLEXITY, AIFIRST, AI_DOC_LINK,
  IMPACTOPTIONS, NO_VD, VD_TO_CLIENT,
  VD_TO_GENPACT, VD_TO_CLIENT_PLUS_GENPACT,GENAIOPTIONS,COMPLETE_STATUS,
  CANCEL,
  AWAITING_MENTOR_APPROVAL_FOR_CANCELLATION

} from "../assets/constants/constants";
import Toast from "light-toast";
import Select from "react-select";

import {
  selectValidation as selectStyle,
  textBoxValidation,
} from "../utils/FieldValidation";
import UpdatedSpeech from "./UpdatedSpeech";
import ValueDelivery from "../utils/ValueDelivery";

export class ReviewIdeaPage extends Component {
  sessionData = JSON.parse(localStorage.getItem(USER_DATA));
  accessToken = localStorage.getItem(ACCESS_TOKEN);
  constructor(props) {
    super(props);
    const isApprovalPage = `${this.props.location.approval}`;
    let propsData = this.props.location;
    this.state = {
      onInitPageTime: "",
      ideaItem: {},
      workflowStatus: "",
      Comment: "",
      accountName: "",
      campaignName: "",
      campaignSelectedOption: null,
      serviceLineSelectedOption: null,
      subServiceLineSelectedOption: null,
      showAdditionalDetails: false,
      serviceLineList: [],
      subServiceLineList: [],
      workFlowStatusList: [],
      workFlowStatusSelectedOption: null,
      certificationLevelsList: [],
      certLevelsSelectedOption: null,
      certificationWorkTypeList: [],
      certWorkTypeSelectedOption: null,
      workTypeEnabled: false,
      displayWorkType: false,
      digitalProjectEnabled: false,
      transformationLeversList: [],
      transSelectedOption: null,
      methodologyList: [],
      methodologySelectedOptions: null,
      databridgeThemeList: [],
      databridgeThemeSelectedOptions: null,
      dataBridgeProjectTheme: null,
      digitalProjectTypeList: [],
      digitalProjectTypeSelectedOptions: null,
      subCampaignList: [],
  
      subCampaignOption: null,
      expectedDate: new Date(),
      leadNameList: [],
      blackbeltOHRList: [],
      LDTLeadSelectedOption: null,
      selectStyle: {},
      businessImpactMasterList: null,
      businessImpactValueArray: [],
      fteTotal: 0,
      dollarTotal: 0.0,
      replicationIDValidated: true,
      approvalPage: isApprovalPage,
      
      mbbSelectedOption: null,
      mbbList: [],
      mbbName: "",
      mbbOHR: "",
      propsData: propsData,
      cancelRequest: true,
      showDigital: false,
      cancelRequestOption: [
        {
          WorkflowStatusId: 1,
          WorkflowStatusName: "Approve Cancellation",
        },
        {
          WorkflowStatusId: 2,
          WorkflowStatusName: "Discard Cancellation",
        },
      ],
      Role: "BB",
      speechModal: false,
      previousTextForSpeech: "",
      CommentEmpty: false,
  
      
   
      finalImpactDollar: 0,
      finalImpactFTE: 0,
      impactOptionSelected: null,
      finalImpactDollar: 0,
      finalImpactFTE: 0,
      businessImpactValueArray: [],
      monetizableProjectSelectedOption: null,
      monetizableCheckbox: null,
      monetizableStatus: false,
      monetizationStatusSelectedOption: null,
      SowID: "",
      FPnANameMonetization: "",
      FPnAOHRMonetization: "",
      FPnAFileNameMonetization: "",
      FPnAFileTypeMonetization: "",
      FPnAFileMonetization: "",
      appropriateAttachment: false,
      lastUpdaterAction: "",
      logRoleState: "",
      displayProjectTheme: false,
      ideaApprovalStatus: "",
      // AI First states starts here
      IsIdeaReplicableSelectedOption: [],
      replicabilityIndexOptions: [
        {
          value: 1,
          label: "1",
        },
        {
          value: 2,
          label: "2",
        },
        {
          value: 3,
          label: "3",
        },
        {
          value: 4,
          label: "4",
        },
        {
          value: 5,
          label: "5",
        },
      ],
      solutionFeasibleSelectedOption: [],
      solutionComplexitySelectedOption: [],

      AIBRD: "",
      AIReason: "",
      showHrefModal: false,
      campaignInsight: "",

      // QA role
      isQAUser: false,

      aiClassificationList: [],
      aiClassificationListSelectedOption: null,
      OtherTools: "",

      
      campaignUnionQuery:null,
      displaySubCampaign:false,

      


    };
    this.isExceedlimit = false;
  }

  async componentDidMount() {
    await this.fetchIdea();
    await this.fetchMetadata();
  }

  fetchMetadata = async () => {
    try {
      const param = {
        EntityType: "",
        EntityName: "",
      };
      const requestOptions = {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          "Authorization": "Bearer " + this.accessToken,
        },
        body: JSON.stringify(param),
      };
      const response = await fetch(GET_METADATA, requestOptions)
      if (response.ok) {
        const data = await response.json();
        if (data) {
          Toast.hide()
          this.setState(
            {
              serviceLineList: data ? data.ServiceLines : [],
              subServiceLineList: data ? data.ServiceLines : [],
              workFlowStatusList: data ? data.WorkflowStatus : [],
              certificationLevelsList: data ? data.CertificationLevels : [],
              certificationWorkTypeList: data ? data.WorkType : [],
              transformationLeversList: data ? data.TransformationLevers : [],
              methodologyList: data ? data.Methodologies : [],
              databridgeThemeList: data ? data.DataBridgeThemes : [],
              subCampaignList: data ? data.SubCampaigns : [],
              digitalProjectTypeList: data ? data.DigitalProjectTypes : [],
              businessImpactMasterList: data ? data.BIMasterDataVerseNew : [],
              aiClassificationList: data ? data.AIClassification : [],
            },
            () => {
              this.IsQAUser()
              this.setSelectedOptions();
              this.setState({ Comment: "" });
              Toast.hide()
            }
          );

        }

      }
    } catch (error) {
      console.log(JSON.stringify(error));
      Toast.fail("Error while getting main metadata. Please try again!", 3000, () => { });
    }
  };


  IsQAUser = async () => {
    try {
      const param = {
        EntityType: "OHR",
        EntityName: this.sessionData ? this.sessionData.profile ? this.sessionData.profile.oHRId : "" : "",
      };
      const requestOptions = {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          "Authorization": "Bearer " + this.accessToken,
        },
        body: JSON.stringify(param),
      };
      const response = await fetch(GET_METADATA, requestOptions)
      if (response.ok) {
        const data = await response.json();
        if (data) {
          data.PowerAppUsers.filter((item) => {
            const userRole = JSON.parse(item.pg_Role).pg_role;
            if (userRole === "QA" && parseInt(this.sessionData.profile.oHRId) === parseInt(item.pg_ohr)) {
              this.setState({ isQAUser: true }, () => { })
            }
          })

        }
      }
    } catch (error) {
      Toast.hide();
      console.log(JSON.stringify(error));
    }
  };


  fetchLDTLeadOptions = async () => {
    try {
      let entityType = "BB";
      let entityName = this.state.ideaItem.RegionManual;
      if (this.state.ideaItem.RegionManual === OTHER_REGIONS) {
        entityType = "BBOTHER";
        entityName = this.state.ideaItem.VerticalManual.replace(" - ", "-");
      }
      const param = {
        EntityType: entityType,
        EntityName: entityName,
      };

      const requestOptions = {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          "Authorization": "Bearer " + this.accessToken,
        },
        body: JSON.stringify(param),
      };
      const response = await fetch(GET_METADATA, requestOptions)
      if (response.ok) {
        const data = await response.json();
        if (data) {
          Toast.hide();
          if (data.DataverseUserRoles) {
            this.setState({
              leadNameList: data.DataverseUserRoles,
              mbbList: data.DataverseUserRoles
            }, () => {
              let filteredLDTLeadList = data.DataverseUserRoles.filter((item) => {
                const userRole = JSON.parse(item.pg_Role).pg_role;
                return (
                  userRole === "LDT Lead" &&
                  parseInt(this.state.ideaItem.OwnerOHR) !== parseInt(item.pg_ohr)
                );
              });

              if (filteredLDTLeadList && filteredLDTLeadList.length > 0) {
                this.setState({
                  leadNameList: filteredLDTLeadList,
                  LDTLeadSelectedOption: {
                    label: filteredLDTLeadList[0].pg_username,
                    value: filteredLDTLeadList[0].pg_ohr,
                  },
                });
              }
            });
          }
        }
      }
    } catch (error) {
      console.log("error =>", error)
      Toast.hide();
      Toast.fail("Error while getting LDT Lead metadata idea. Please try again!", 3000, () => { });
    }
  };

  setSelectedOptions = () => {
    if (this.state.ideaItem.MBBOHR) {
      this.setState({
        mbbSelectedOption: {
          value: this.state.ideaItem.MBBOHR,
          label: this.state.ideaItem.MBBName,
        },
        mbbOHR: this.state.ideaItem.MBBOHR,
        mbbName: this.state.ideaItem.MBBName,
      });
    }
    this.state.serviceLineList.map((item) => {
      if (this.state.ideaItem.ServiceLineName === item.ServiceLineName) {
        this.setState({
          serviceLineSelectedOption: {
            value: item.ServiceLineName,
            label: item.ServiceLineName,
          },
        });
      }
      return 1;
    });
    this.state.subServiceLineList.map((item) => {
      if (this.state.ideaItem.SubServiceLine === item.SubServiceLineName) {
        this.setState({
          subServiceLineSelectedOption: {
            value: item.SubServiceLineId,
            label: item.SubServiceLineName,
          },
        });
      }
      return 1;
    });


    if (this.state.displayProjectTheme && this.state.campaignSelectedOption?.label === DATA_BRIDGE_CAMPAIGN) {
      this.state.databridgeThemeList && this.state.databridgeThemeList.map((item) => {
        if (this.state.ideaItem.DataBridgeTheme === item.DBProjectThemeName) {
          this.setState({
            dataBridgeProjectTheme:item.DBProjectThemeName,
            databridgeThemeSelectedOptions: {
              value: item.ThemeId,
              label: item.DBProjectThemeName,
            },
          });
        }
        return 1;
      });
    }
  };

  fetchIdea = async() => {
    try{
      Toast.loading("Fetching Idea and metadata...", () => { });
      const requestOptions = {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
          "Authorization": "Bearer " + this.accessToken,
        },
      };
      const response = await fetch(`${GET_IDEA_URL}IdeaId=${this.props.location.state}&case=data&casetype=fetchIdeaDetails`, requestOptions)
      if(response.ok){
        const data = await response.json();
        if(data){
          Toast.hide()
          console.log("fetch Idea", data);
          this.setState(
            {
              ideaItem: data.ResultSets.Table1[0],
              workflowStatus: data.ResultSets.Table1[0].WorkflowStatus,
              Comment: data.ResultSets.Table1[0].Comment,
              reviewComments: data.ReviewComments ? data.ReviewComments :[],
              finalReviewComments: data.FinalReviewComments ? data.FinalReviewComments : [],
              expectedDate: data.ResultSets.Table1[0].ExpectedFinishDate === null ? new Date() : new Date(data.ResultSets.Table1[0].ExpectedFinishDate),
  
              dataBridgeProjectTheme: data.ResultSets.Table1[0].DataBridgeTheme ? data.ResultSets.Table1[0].DataBridgeTheme : "",
         
              isAI: data.ResultSets ? data.ResultSets.Table1[0].isAI : [],
              AIBRD: data.IdeasAI ? data.IdeasAI[0] ?  data.IdeasAI[0].LinkBRD : "":"",
              AIReason: data.IdeasAI ? data.IdeasAI[0] ? data.IdeasAI[0].AIReason: "" : "",

              OtherTools: data.ResultSets ? data.ResultSets.Table1[0].OtherTools : "",

              campaignUnionQuery:data.CampaignDetails.ResultSets.Table1,
              vdForComponent:data.BIData ? data.BIData : [],

            
              
            },
            () => {

              if (this.state.campaignUnionQuery) {
                let filteredUnionQuery = this.state.campaignUnionQuery.filter((item) => {
                  return item.CampaignID === this.state.ideaItem.CampaignID
                })
                if (filteredUnionQuery) {
                  if (filteredUnionQuery[0]) {
                    this.setState({
                      campaignInsight: filteredUnionQuery[0].CampaignDescr,
                      campaignSelectedOption: {
                        value: filteredUnionQuery[0].CampaignID,
                        label: filteredUnionQuery[0].Campaign,
                      },
                    }, () => { }
                    );
                  }
                }

                // from fetch idea if campaign is selected as genai then display genai sub campaign from genai local options or else choose from the union query
                if (this.state.ideaItem.CampaignName === "Gen AI") {
                  GENAIOPTIONS.map((item) => {
                    if (item.label === this.state.ideaItem.SubCampaignName) {
                      this.setState({
                        subCampaignOption: item,
                        displaySubCampaign: true
                      }, () => {

                      });
                    }
                  });
                } else {
                  // from union query - 
                  let options = [];
                  let result = [];
                  this.state.campaignUnionQuery.map((item) => {
                    if (this.state.ideaItem.CampaignID === item.CampaignID) {
                      if (item.SubCampaign) {
                        options.push({ value: item.SubCampaignID, label: item.SubCampaign });
                      }
                    }
                    return true;
                  });
                  result = options.reduce((unique, index) => {
                    if (!unique.some(obj => obj.label === index.label && obj.value === index.value)) {
                      unique.push(index);
                    }
                    return unique;
                  }, []);
                  if (result.length > 0) {
                    this.setState({ displaySubCampaign: true }, () => { })
                    result.map((item) => {
                      if (this.state.ideaItem.SubCampaignID === item.value) {
                        this.setState({ subCampaignOption: item });
                      }
                    })
                  }
                }
              }


              if (this.state.ideaItem.ModifiedDate) {
                this.setState({
                  onInitPageTime: this.state.ideaItem.ModifiedDate,
                })
              }
              if (this.state.ideaItem.CreatedDate) {
                let created = new Date(this.state.ideaItem.CreatedDate);
                let abc = new Date(DISPLAYPROJECTTHEME);
                if (created.getTime() < abc.getTime()) {
                  //console.log("created date is lesser")
                  this.setState({ displayProjectTheme: true });
                } else {
                  this.setState({ displayProjectTheme: false });
                  //console.log("created date is greater ")
                }
              }

              if (this.state.reviewComments.length > 0) {
                let logAction = this.state.reviewComments[
                  this.state.reviewComments.length - 1
                ].UpdaterAction
                  ? this.state.reviewComments[
                    this.state.reviewComments.length - 1
                  ].UpdaterAction
                  : this.state.reviewComments[
                    this.state.reviewComments.length - 1
                  ].Action;
                let logRole =
                  this.state.reviewComments[
                    this.state.reviewComments.length - 1
                  ].UpdaterRole;
                this.setState(
                  {
                    logAction: logAction,
                    logRoleState: logRole,
                  },
                  () => {
                    //console.log("log action is",  this.state.reviewComments[this.state.reviewComments.length-1].UpdaterAction)
                  }
                );
              }
              if (this.state.reviewComments.length > 0) {
                var keys = Object.keys(this.state.reviewComments);
                var last = keys[keys.length - 1];
                let varLastUpdaterAction =
                  this.state.reviewComments[last].UpdaterAction;
                this.setState(
                  { lastUpdaterAction: varLastUpdaterAction },
                  () => { }
                );
              }
             
              this.fetchLDTLeadOptions();
              
              if (this.state.ideaItem.WorkflowStatus === AWAITING_MENTOR_APPROVAL_FOR_CANCELLATION && this.state.ideaItem.ApprovalStatus === "NA") {
                this.setState({ CommentEmpty: true, Comment: "" }, () => {});
              }
              if (this.state.ideaItem.WorkflowStatus === "Approve" && this.state.ideaItem.ApprovalStatus === AWAITING_MENTOR_APPROVAL_FOR_CANCELLATION ) {
                this.setState({ CommentEmpty: true, Comment: "" }, () => {});
              }
              
            }
          );

        }
      }

    }catch(err){
      console.log(JSON.stringify(err))
      Toast.fail("Error while fetching Idea details. Please try again!",3000,() => { });
    }
  };

  

  handleCommentChange = (event) => {
    this.setState({
      Comment: event.target.value,
    });
  };

  handleTranscriptCommentChange = (e) => {
    let trimmedText = e.trim();
    this.setState({
      Comment: trimmedText,
    });
  };

  validate = () => {
    let isValid = true;
    this.isExceedlimit = false;
    let styleStateObj = this.state.selectStyle;

    if (this.state.campaignSelectedOption === "" || this.state.campaignSelectedOption === null || this.state.campaignSelectedOption === undefined || !this.state.campaignSelectedOption) {
      isValid = false;
      styleStateObj.campaignSelectedOption = selectStyle(false);
      this.setState({
        selectStyle: styleStateObj,
      });
    } else {
      styleStateObj.campaignSelectedOption = selectStyle(true);
      this.setState({
        selectStyle: styleStateObj,
      });
    }
    

    if (this.state.ideaItem.ServiceLineName === "") {
      isValid = false;
      styleStateObj.ServiceLineName = selectStyle(false);
      this.setState({
        selectStyle: styleStateObj,
      });
    } else {
      styleStateObj.ServiceLineName = selectStyle(true);
      this.setState({
        selectStyle: styleStateObj,
      });
    }

    if (this.state.ideaItem.SubServiceLine === "") {
      isValid = false;
      styleStateObj.subServiceLine = selectStyle(false);
      this.setState({
        selectStyle: styleStateObj,
      });
    } else {
      styleStateObj.subServiceLine = selectStyle(true);
      this.setState({
        selectStyle: styleStateObj,
      });
    }

    if (this.state.ideaItem.Problem === "") {
      isValid = false;
      styleStateObj.Problem = textBoxValidation(false);
      this.setState({
        selectStyle: styleStateObj,
      });
    } else {
      if (this.state.ideaItem.Problem.length > 2000) {
        Toast.fail(
          "Problem statement cannot be more than 2000 characters, please change and resubmit.",
          3000
        );
        isValid = false;
        styleStateObj.Problem = textBoxValidation(false);
        this.setState({
          selectStyle: styleStateObj,
        });
      } else {
        styleStateObj.Problem = {
          ...textBoxValidation(true),
          border: "1px solid lightgrey",
        };
        this.setState({
          selectStyle: styleStateObj,
        });
      }
    }

    if (this.state.ideaItem.Solution === "") {
      isValid = false;
      styleStateObj.Solution = textBoxValidation(false);
      this.setState({
        selectStyle: styleStateObj,
      });
    } else {
      if (this.state.ideaItem.Solution.length > 2000) {
        Toast.fail(
          "Solution statement cannot be more than 2000 characters, please change and resubmit.",
          3000
        );
        isValid = false;
        styleStateObj.Solution = textBoxValidation(false);
        this.setState({
          selectStyle: styleStateObj,
        });
      } else {
        styleStateObj.Solution = {
          ...textBoxValidation(true),
          border: "1px solid lightgrey",
        };
        this.setState({
          selectStyle: styleStateObj,
        });
      }
    }
    if (
      this.state.ideaItem.NewOrReplicatedIdea &&
      this.state.ideaItem.ReplicationProjectId === ""
    ) {
      isValid = false;
      styleStateObj.ReplicationProjectId = textBoxValidation(false);
      this.setState({
        selectStyle: styleStateObj,
      });
    } else {
      if (
        this.state.ideaItem.NewOrReplicatedIdea &&
        this.state.ideaItem.ReplicationProjectId !== "" &&
        !this.state.replicationIDValidated
      ) {
        // if (!this.validateReplicationId(this.state.ideaItem.ReplicationProjectId)) {
        isValid = false;
        styleStateObj.ReplicationProjectId = textBoxValidation(false);
        this.setState({
          selectStyle: styleStateObj,
        });
        // } else {
        //     styleStateObj.ReplicationProjectId = { ...textBoxValidation(true), border: "1px solid lightgrey" };
        //     this.setState({
        //         selectStyle: styleStateObj
        //     })
        // }
      } else {
        styleStateObj.ReplicationProjectId = {
          ...textBoxValidation(true),
          border: "1px solid lightgrey",
        };
        this.setState({
          selectStyle: styleStateObj,
        });
      }
    }

    if (this.state.workFlowStatusSelectedOption === null) {
      isValid = false;
      styleStateObj.workFlowStatusSelectedOption = selectStyle(false);
      this.setState({
        selectStyle: styleStateObj,
      });
    } else {
      styleStateObj.workFlowStatusSelectedOption = selectStyle(true);
      this.setState({
        selectStyle: styleStateObj,
      });
    }

    if (this.state.expectedDate === "") {
      isValid = false;
      styleStateObj.expectedDate = textBoxValidation(false);
      this.setState({
        selectStyle: styleStateObj,
      });
    } else {
      styleStateObj.expectedDate = {
        ...textBoxValidation(true),
        border: "1px solid lightgrey",
      };
      this.setState({
        selectStyle: styleStateObj,
      });
    }

    if (!this.state.Comment || this.state.Comment === "") {
      isValid = false;
      styleStateObj.comment = textBoxValidation(false);
      this.setState({
        selectStyle: styleStateObj,
      });
    } else {
      if (this.state.Comment.length > 500) {
        Toast.fail(
          "Comment cannot be more than 500 characters, please change and resubmit.",
          3000
        );
        isValid = false;
        this.isExceedlimit = true;
        styleStateObj.comment = textBoxValidation(false);
        this.setState({
          selectStyle: styleStateObj,
        });
      } else {
        styleStateObj.comment = {
          ...textBoxValidation(true),
          border: "1px solid lightgrey",
        };
        this.setState({
          selectStyle: styleStateObj,
        });
      }
    }
    

    
    if (this.state.showAdditionalDetails && this.state.certWorkTypeSelectedOption === null) {
      if ( this.state.certLevelsSelectedOption?.label === "GB" && (this.state.transSelectedOption?.label === "Continuous Improvement")) {
        isValid = false;
        styleStateObj.certWorkTypeSelectedOption = selectStyle(false);
        this.setState({
          selectStyle: styleStateObj,
        });
      } else {
        styleStateObj.certWorkTypeSelectedOption = selectStyle(true);
        this.setState({
          selectStyle: styleStateObj,
        });
      }
    } else {
      styleStateObj.certWorkTypeSelectedOption = selectStyle(true);
      this.setState({
        selectStyle: styleStateObj,
      });
    }

    

    

    if (this.state.showAdditionalDetails) {

      if (this.state.LDTLeadSelectedOption === null || this.state.LDTLeadSelectedOption === undefined || this.state.LDTLeadSelectedOption === "" || !this.state.LDTLeadSelectedOption) {
        isValid = false;
        styleStateObj.LDTLeadSelectedOption = selectStyle(false);
        this.setState({
          selectStyle: styleStateObj,
        });
      } else {
        styleStateObj.LDTLeadSelectedOption = selectStyle(true);
        this.setState({
          selectStyle: styleStateObj,
        });
      }

      if (this.state.certLevelsSelectedOption === null || this.state.certLevelsSelectedOption === undefined || this.state.certLevelsSelectedOption === "" || !this.state.certLevelsSelectedOption) {
        isValid = false;
        styleStateObj.certLevelsSelectedOption = selectStyle(false);
        this.setState({
          selectStyle: styleStateObj,
        });
      } else {
        styleStateObj.certLevelsSelectedOption = selectStyle(true);
        this.setState({
          selectStyle: styleStateObj,
        });
      }
      
      if (this.state.transSelectedOption === null || this.state.transSelectedOption === undefined || this.state.transSelectedOption === "" || !this.state.transSelectedOption) {
        isValid = false;
        styleStateObj.transSelectedOption = selectStyle(false);
        this.setState({
          selectStyle: styleStateObj,
        });
      } else {
        styleStateObj.transSelectedOption = selectStyle(true);
        this.setState({
          selectStyle: styleStateObj,
        });
      }

      if (this.state.transSelectedOption && this.state.transSelectedOption.label === "Digital") {
        if (this.state.digitalProjectTypeSelectedOptions === null || this.state.digitalProjectTypeSelectedOptions === undefined || !this.state.digitalProjectTypeSelectedOptions || this.state.digitalProjectTypeSelectedOptions.length === 0) {
          isValid = false;
          styleStateObj.digitalProjectTypeSelectedOptions = selectStyle(false);
          this.setState({
            selectStyle: styleStateObj
          })
        } else {
          styleStateObj.digitalProjectTypeSelectedOptions = selectStyle(true);
          this.setState({
            selectStyle: styleStateObj
          })
        }
      }
      
      if (this.state.methodologySelectedOptions === null || this.state.methodologySelectedOptions === undefined || !this.state.methodologySelectedOptions || this.state.methodologySelectedOptions.length === 0) {
        isValid = false;
        styleStateObj.methodologySelectedOptions = selectStyle(false);
        this.setState({
          selectStyle: styleStateObj,
        });
      }
      else {
        styleStateObj.methodologySelectedOptions = selectStyle(true);
        this.setState({
          selectStyle: styleStateObj,
        });
      }

      if (this.state.aiClassificationListSelectedOption === null || this.state.aiClassificationListSelectedOption === undefined || this.state.aiClassificationListSelectedOption.length === 0 || !this.state.aiClassificationListSelectedOption) {
        isValid = false;
        styleStateObj.aiClassificationListSelectedOption = selectStyle(false)
        this.setState({
          selectStyle: styleStateObj
        })
      }
      else {
        styleStateObj.aiClassificationListSelectedOption = selectStyle(true)
        this.setState({
          selectStyle: styleStateObj
        })
      }

    }

    if (!this.state.ideaItem.MBBOHR && this.state.ideaItem.WorkflowStatus !== AWAITING_MENTOR_APPROVAL_FOR_CANCELLATION && this.state.ideaItem.ApprovalStatus !== AWAITING_MENTOR_APPROVAL_FOR_CANCELLATION) {
      if (this.state.mbbOHR === "" || this.state.mbbOHR === null || this.state.mbbOHR === undefined || !this.state.mbbOHR) {
        isValid = false;
        styleStateObj.mbbUserName = selectStyle(false);
        this.setState({
          selectStyle: styleStateObj,
        });
      } else {
        styleStateObj.mbbUserName = selectStyle(true);
        this.setState({
          selectStyle: styleStateObj,
        });
      }
    }


    if (this.state.displaySubCampaign) {
      if ( this.state.subCampaignOption === null || this.state.subCampaignOption === "" || this.state.subCampaignOption === undefined || !this.state.subCampaignOption) {
        isValid = false;
        styleStateObj.subCampaignOption = selectStyle(false);
        this.setState({
          selectStyle: styleStateObj,
        });
      } else {
        styleStateObj.subCampaignOption = selectStyle(true);
        this.setState({
          selectStyle: styleStateObj,
        });
      }
    }

    // validations copied from final-review-idea-page starts here

    if (
      this.state.certLevelsSelectedOption &&
      this.state.certLevelsSelectedOption.label === "Lean"
    ) {
      if (this.state.impactOptionSelected === null) {
        isValid = false;
        Toast.fail("Please select Value Delivery Type", 3000, () => { });
      }
    }

    if (
      this.state.certLevelsSelectedOption &&
      this.state.certLevelsSelectedOption.label === "Lean" &&
      this.state.impactOptionSelected &&
      this.state.impactOptionSelected.label !== NO_VD
    ) {
      if (this.state.businessImpactValueArray.length === 0) {
        Toast.fail("Value Delivery cannot be empty, please fill and resubmit.", 3000, () => { });
        isValid = false;
      } else {
        if (this.state.finalImpactDollar <= 0) {
          Toast.fail(
            "Total Dollar Impact cannot be zero. Please check and resubmit.",
            3000,
            () => { }
          );
          isValid = false;
        }
        if (this.state.finalImpactFTE > 0 && this.state.finalImpactDollar <= 0) {
          Toast.fail("Total Impact Dollar cannot be zero when FTE is non-zero. Please check and resubmit.", 3000, () => { });
          isValid = false;
        }


        let showFTEImpactError = false;
        let showDollarImpactError = false;
        let FTEGreaterThanDollar = false;
        let myBIMasterList = this.state.businessImpactMasterList && this.state.businessImpactMasterList;
        this.state.businessImpactValueArray.filter((item) => {
          if (parseFloat(item.DollarImpact) === 0 || parseFloat(item.DollarImpact) === "" || !item.DollarImpact || item.DollarImpact === null) {
            showDollarImpactError = true;
          }
          for (const pg_item of myBIMasterList) {
            if (item.ImpactType === pg_item.pg_impacttype && item.MonetizableType === pg_item.pg_monetizabletype && item.BISubCategory === pg_item.pg_bisubcategory && pg_item.pg_isfteimpact === "Yes") {
              if (!item.FTEImpact || parseFloat(item.FTEImpact) === 0 || item.FTEImpact === null || item.FTEImpact === undefined || item.FTEImpact === "") {
                showFTEImpactError = true;
              }
            }
          }
          if (item && item.isFTEPresent === true) {
            if (parseFloat(item.FTEImpact) > parseFloat(item.DollarImpact)) {
              FTEGreaterThanDollar = true;
            }
          }
        });
        if (showFTEImpactError === true) {
          isValid = false;
          Toast.fail("FTE Impact value cannot be zero", 3000, () => { });
        }
        if (showDollarImpactError === true) {
          isValid = false;
          Toast.fail("Dollar Impact value cannot be zero.", 3000, () => { });
        }
        if (FTEGreaterThanDollar === true) {
          isValid = false;
          Toast.fail("FTE impact value cannot be greater than dollar value", 3000, () => { });
        }
      }

      if (
        this.state.impactOptionSelected &&
        this.state.impactOptionSelected.label !== NO_VD
      ) {
        // if (this.state.monetizableProjectSelectedOption === null) {
        //   isValid = false;
        //   Toast.fail("Please select monetizatable project", 3000, () => {});
        // }
        if (this.state.monetizableProjectSelectedOption === null ||
          this.state.monetizableProjectSelectedOption.length === 0 ||
          this.state.monetizableProjectSelectedOption === undefined
        ) {
          isValid = false;
          Toast.fail("Please select monetizatable project", 5000, () => { });
        }
      }

      if (
        this.state.impactOptionSelected.label ===
        VD_TO_CLIENT_PLUS_GENPACT
      ) {
        if (this.state.businessImpactValueArray.length > 0) {
          let impactGenpactTrue = this.state.businessImpactValueArray.some(
            (vendor) => vendor["ImpactType"] === "Impact at Genpact"
          );
          let impactClientTrue = this.state.businessImpactValueArray.some(
            (vendor) => vendor["ImpactType"] === "Impact at Client"
          );
          if (impactGenpactTrue === false) {
            isValid = false;
            Toast.fail("Please add both Impact types.", 3000, () => { });
          }
          if (impactClientTrue === false) {
            isValid = false;
            Toast.fail("Please add both Impact types.", 3000, () => { });
          }
        }
      }
      if (this.state.impactOptionSelected) {
        if (
          this.state.monetizableProjectSelectedOption &&
          this.state.monetizableProjectSelectedOption.label === "Yes"
        ) {
          if (this.state.monetizationStatusSelectedOption === null || !this.state.monetizationStatusSelectedOption ||
            this.state.monetizationStatusSelectedOption === undefined || this.state.monetizationStatusSelectedOption.length === 0
          ) {
            isValid = false;
            Toast.fail(
              "Since this project has been marked as Monetizable, monetizable status has to be selected",
              5000,
              () => { }
            );
          }
        }
        if (
          this.state.monetizableProjectSelectedOption !== null &&
          this.state.monetizationStatusSelectedOption !== null
        ) {
          if (this.state.monetizableProjectSelectedOption.label === "Yes")
            if (
              this.state.businessImpactValueArray.filter(
                (item) => item.IsMonetized === "Yes"
              ).length > 0
            ) {
            } else {
              isValid = false;
              Toast.fail(
                "Since this is a monetizable project, there needs to be at least one impact type as ‘Impact at Genpact’ selected and category selected as a ‘Increase in Revenue’ .",
                5000,
                () => { }
              );
            }
        }
        if (
          this.state.monetizableProjectSelectedOption &&
          this.state.monetizableProjectSelectedOption.label === "Yes"
        ) {
          if (
            this.state.monetizationStatusSelectedOption &&
            this.state.monetizationStatusSelectedOption.label ===
            "Approved by Client"
          ) {
            if (
              this.state.SowID === "" ||
              this.state.SowID === null ||
              this.state.SowID === undefined ||
              this.state.SowID.length === 0 ||
              !this.state.SowID
            ) {
              isValid = false;
              Toast.fail(
                "Please fill SOW ID/SFDC/OLI ID for monetization",
                3000,
                () => { }
              );
            }
          }
        }
      }
    }
    // validations copied from final-review-idea-page ends here


    // AI First validations starts here

    if (this.state.workFlowStatusSelectedOption && this.state.workFlowStatusSelectedOption.label === "Approve") {
      if (this.state.campaignSelectedOption?.label === AIFIRST) {
        if (this.state.IsIdeaReplicableSelectedOption === null || this.state.IsIdeaReplicableSelectedOption.length === 0 || this.state.IsIdeaReplicableSelectedOption === undefined ||!this.state.IsIdeaReplicableSelectedOption) {
          isValid = false;
          styleStateObj.IsIdeaReplicableSelectedOption = selectStyle(false);
          this.setState({
            selectStyle: styleStateObj,
          });
        } else {
          styleStateObj.IsIdeaReplicableSelectedOption = selectStyle(true);
          this.setState({
            selectStyle: styleStateObj,
          });
        }

        if (this.state.solutionFeasibleSelectedOption === null || this.state.solutionFeasibleSelectedOption.length === 0 || this.state.solutionFeasibleSelectedOption === undefined || !this.state.solutionFeasibleSelectedOption) {
          isValid = false;
          styleStateObj.solutionFeasibleSelectedOption = selectStyle(false);
          this.setState({
            selectStyle: styleStateObj,
          });
        } else {
          styleStateObj.solutionFeasibleSelectedOption = selectStyle(true);
          this.setState({
            selectStyle: styleStateObj,
          });
        }

        if ( this.state.solutionComplexitySelectedOption === null || this.state.solutionComplexitySelectedOption.length === 0 || this.state.solutionComplexitySelectedOption === undefined || !this.state.solutionComplexitySelectedOption) {
          isValid = false;
          styleStateObj.solutionComplexitySelectedOption = selectStyle(false);
          this.setState({
            selectStyle: styleStateObj,
          });
        } else {
          styleStateObj.solutionComplexitySelectedOption = selectStyle(true);
          this.setState({
            selectStyle: styleStateObj,
          });
        }
      }
    }

    return isValid;
  };
  submitIdea = () => {
    // Code change bh TR
    if (Number(this.state.ideaItem.BlackBeltUserId) === Number(this.sessionData.profile.oHRId)) {   //bug fix stakeholder changes 2
      // Code change bh TR

      if (this.validate()) {
        let ApprovalStatus = "";
        if (this.state.certLevelsSelectedOption && this.state.certLevelsSelectedOption.label === "GB") {
          ApprovalStatus = "Awaiting Project Creation";
        }
        if (this.state.certLevelsSelectedOption && this.state.certLevelsSelectedOption.label === "Lean") {
          ApprovalStatus = "PD"
        }

        let selectedLabels = '';
        let selectedValues = '';
        if (this.state.methodologySelectedOptions) {
          selectedLabels = this.state.methodologySelectedOptions.map(option => `${option.label}`).join('|');
          selectedValues = this.state.methodologySelectedOptions.map(option => option.value).join('|')
        }
        if (this.props.location.approval === "approval") {
          if (window.confirm("Are you sure you want to update the idea ?")) {
            Toast.loading("Updating idea...", () => { });
            let param = {};
            if (
              this.state.workFlowStatusSelectedOption.label === "Approve Cancellation" ||
              this.state.workFlowStatusSelectedOption.label === "Discard Cancellation"
            ) {
              if (this.state.workFlowStatusSelectedOption.label === "Approve Cancellation") {
                param = {
                  OnInitPageTime: this.state.onInitPageTime,

                  IdeaId: this.props.location.state,
                  ApprovalStatus: this.state.ideaItem.ApprovalStatus !== "NA" ? CANCEL : "NA",
                  UpdaterOHR: this.sessionData.profile.oHRId,
                  UpdaterEmail: this.sessionData.profile.oHRId + "@genpact.com",
                  UpdaterName:
                    this.sessionData.profile.lastName + ", " + this.sessionData.profile.firstName,
                  comment: this.state.Comment,
                  WorkflowStatus:
                    this.state.ideaItem.WorkflowStatus !== AWAITING_MENTOR_APPROVAL_FOR_CANCELLATION
                      ? this.state.ideaItem.WorkflowStatus
                      : CANCEL,
                  ProjectStatus:
                    this.state.ideaItem.WorkflowStatus === "Approve" ||
                      this.state.ideaItem.WorkflowStatus === "Approved"
                      ? "Pending Documents"
                      : "NA",
                  Role: "Mentor",
                  updaterAction: "Approved",
                };
              } else {
                if (this.state.ideaItem.WorkflowStatus === AWAITING_MENTOR_APPROVAL_FOR_CANCELLATION) {
                  param = {
                    OnInitPageTime: this.state.onInitPageTime,

                    IdeaId: this.props.location.state,
                    ApprovalStatus: "NA",
                    UpdaterOHR: this.sessionData.profile.oHRId,
                    UpdaterEmail: this.sessionData.profile.oHRId + "@genpact.com",
                    UpdaterName:
                      this.sessionData.profile.lastName +
                      ", " +
                      this.sessionData.profile.firstName,
                    comment: this.state.Comment,
                    WorkflowStatus: "Pending",
                    RejectCancel: true,
                    Role: "Mentor",
                    updaterAction: "Discard Cancellation",
                  };
                } else {
                  param = {
                    OnInitPageTime: this.state.onInitPageTime,
                    IdeaId: this.props.location.state,
                    ApprovalStatus: "Pending Documents",
                    UpdaterOHR: this.sessionData.profile.oHRId,
                    UpdaterEmail: this.sessionData.profile.oHRId + "@genpact.com",
                    UpdaterName:
                      this.sessionData.profile.lastName +
                      ", " +
                      this.sessionData.profile.firstName,
                    comment: this.state.Comment,
                    WorkflowStatus: "Approve",
                    RejectCancel: true,
                    Role: "Mentor",
                    updaterAction: "Pending Documents",
                  };
                }
              }
            } else {
              this.state.businessImpactValueArray =
                this.state.businessImpactValueArray
                  .map((item) => ({
                    ...item,
                    pg_srno: item.SrNo,
                    dollarValue: item.DollarImpact,
                    fteValue: item.FTEImpact,
                  }))
                  .map((item) => {
                    return item;
                  });

              let filteredBIData = this.state.businessImpactValueArray.filter(
                function (e) {
                  return e !== null && e !== undefined;
                }
              );
              param = {
                OnInitPageTime: this.state.onInitPageTime,
                IdeaName: this.state.ideaItem.IdeaName,
                Problem: this.state.ideaItem.Problem,
                Solution: this.state.ideaItem.Solution,
                ServiceLineId: this.state.ideaItem.ServiceLineId,
                ServiceLineName: this.state.ideaItem.ServiceLineName,
                SubServiceLine: this.state.ideaItem.SubServiceLine,
                UpdaterOHR: this.sessionData.profile.oHRId,
                UpdaterEmail: this.sessionData.profile.oHRId + "@genpact.com",
                UpdaterName:
                  this.sessionData.profile.lastName +
                  ", " +
                  this.sessionData.profile.firstName,
                WorkflowStatusId:
                  this.state.workFlowStatusSelectedOption !== null
                    ? this.state.workFlowStatusSelectedOption.value
                    : null,
                WorkflowStatus:
                  this.state.workFlowStatusSelectedOption !== null
                    ? this.state.workFlowStatusSelectedOption.label
                    : null,
                ExpectedFinishDate:
                  this.state.workFlowStatusSelectedOption.label === "Approve"
                    ? new Date(this.state.expectedDate).toISOString()
                    : null,
                Comment: this.state.Comment,
                IdeaId: this.props.location.state,
                NewOrReplicatedIdea: this.state.ideaItem.NewOrReplicatedIdea,
                ReplicationProjectId: this.state.ideaItem.NewOrReplicatedIdea
                  ? this.state.ideaItem.ReplicationProjectId
                  : "",
                // PotentialImpactDollar: this.state.ideaItem.PotentialImpactDollar,
                PotentialImpactFTE: this.state.ideaItem.PotentialImpactFTE,

                CertificationWorkTypeName:this.state.certWorkTypeSelectedOption?.value,
                CertificationLevelId:this.state.certLevelsSelectedOption?.value,
                CertificationLevelName: this.state.certLevelsSelectedOption?.label,
                
                TLID: this.state.transSelectedOption?.value ? this.state.transSelectedOption.value : "",
                TransformationLeverName:this.state.transSelectedOption?.label ? this.state.transSelectedOption?.label : "",
                
                DigitalProjectType: this.state.digitalProjectTypeSelectedOptions?.label ? this.state.digitalProjectTypeSelectedOptions?.label : "",
                DPTypeID:this.state.digitalProjectTypeSelectedOptions?.value ? this.state.digitalProjectTypeSelectedOptions?.value : "",
                IsDigital: this.state.transSelectedOption?.label === "Digital" ? true : false ,

                MethodologyTypeID: selectedValues,
                MethodologyName: selectedLabels,
                
                AIClassification: this.state.showAdditionalDetails && this.state.aiClassificationListSelectedOption !== null ? this.state.aiClassificationListSelectedOption.label : null,
                AIClassificationId: this.state.showAdditionalDetails && this.state.aiClassificationListSelectedOption !== null ? this.state.aiClassificationListSelectedOption.value : null,

                OtherTools: this.state.OtherTools,

                LDTId: this.state.LDTLeadSelectedOption?.value,
                LDTName: this.state.LDTLeadSelectedOption?.label,
                IsReplicationVerified: this.state.ideaItem.IsReplicationVerified,
                
                BusinessImpactData: filteredBIData,
                
                
               
                CampaignID:this.state.campaignSelectedOption?.value ? this.state.campaignSelectedOption?.value : "",
                CampaignName: this.state.campaignSelectedOption?.label ? this.state.campaignSelectedOption?.label : "",

                DataBridgeTheme: this.state.dataBridgeProjectTheme ? this.state.dataBridgeProjectTheme : "",
                SubCampaignName: this.state.subCampaignOption?.label,
                SubCampaignID: this.state.subCampaignOption?.value,
                
                MBBOHR: Number(this.state.mbbOHR),
                MBBName: this.state.mbbName,
                Role: "Mentor",
                updaterAction: this.state.workFlowStatusSelectedOption
                  ? this.state.workFlowStatusSelectedOption.label === "Approve"
                    ? "Approved"
                    : this.state.workFlowStatusSelectedOption.label
                  : "",

                VDType: this.state.impactOptionSelected
                  ? this.state.impactOptionSelected.label
                  : this.state.ideaItem.VDType,
                FinalImpactDollar: this.state.finalImpactDollar
                  ? this.state.finalImpactDollar
                  : null,
                FinalImpactFTE: this.state.finalImpactFTE
                  ? this.state.finalImpactFTE
                  : null,
                FPnAOHRMonetization: this.state.FPnAOHRMonetization
                  ? this.state.FPnAOHRMonetization
                  : "",
                FPnANameMonetization: this.state.FPnAOHRMonetization
                  ? this.state.FPnANameMonetization
                  : "",
                SowID: this.state.SowID ? this.state.SowID : "",
                IsVDMonetizable: this.state.monetizableProjectSelectedOption
                  ? this.state.monetizableProjectSelectedOption.label
                  : "",
                MonetizationStatus: this.state.monetizationStatusSelectedOption
                  ? this.state.monetizationStatusSelectedOption.label
                  : "",
                //AI First
                isAI: this.state.isAI,
                ApprovalStatus: ApprovalStatus,
                IsIdeaReplicable: this.state.IsIdeaReplicableSelectedOption ? this.state.IsIdeaReplicableSelectedOption.label === "Yes" ? 1 : 0 : "",
                IsSolnFeasible: this.state.solutionFeasibleSelectedOption ? this.state.solutionFeasibleSelectedOption.label === "Yes" ? 1 : 0 : "",
                SolnComplexity: this.state.solutionComplexitySelectedOption ? this.state.solutionComplexitySelectedOption.label : "",
                LinkBRD: this.state.AIBRD,
                AIReason: this.state.AIReason,

                
              };
            }
            console.log(param);
           
            const requestOptions = {
              method: "PUT",
              headers: {
                "Content-Type": "application/json",
                "Authorization": "Bearer " + this.accessToken,
              },
              body: JSON.stringify(param),
            };
            fetch(`${REVIEW_IDEA_URL}`, requestOptions)
              .then((response) => {
                // Code change by TR
                return response.json().then((data) => {
                  if (response.status === 409) {
                    Toast.fail("This Idea has been updated by another stakeholder. Please open the Idea again to view the latest details.", 5000);

                    setTimeout(() => {
                      window.location.href = "/review-page";
                    }, 5000);

                    return null;
                  }

                  return data;
                });
              })
              .then((data) => {
                if (!data) {
                  return;
                }
                // Code change by TR
                Toast.hide();
                Toast.success("Updated successfully.", 3000, () => {
                  let redirectURL = "/review-page";
                  if (this.state.approvalPage) {
                    redirectURL =
                      redirectURL + "?page=" + this.state.approvalPage;
                  }
                  window.location = redirectURL;
                });
              });
          }
        } else {
          if (window.confirm("Are you sure you want to update the Project?")) {
            Toast.loading("Updating Project...", () => { });


            let param = {};
            if (
              this.state.workFlowStatusSelectedOption.label ===
              "Approve Cancellation" ||
              this.state.workFlowStatusSelectedOption.label ===
              "Discard Cancellation"
            ) {
              if (
                this.state.workFlowStatusSelectedOption.label ===
                "Approve Cancellation"
              ) {
                param = {
                  OnInitPageTime: this.state.onInitPageTime,
                  IdeaId: this.props.location.state,
                  ApprovalStatus: this.state.ideaItem.ApprovalStatus !== "NA" ? CANCEL : "NA",
                  UpdaterOHR: this.sessionData.profile.oHRId,
                  UpdaterEmail: this.sessionData.profile.oHRId + "@genpact.com",
                  UpdaterName:
                    this.sessionData.profile.lastName +
                    ", " +
                    this.sessionData.profile.firstName,
                  comment: this.state.Comment,
                  WorkflowStatus:
                    this.state.ideaItem.WorkflowStatus !== AWAITING_MENTOR_APPROVAL_FOR_CANCELLATION
                      ? this.state.ideaItem.WorkflowStatus
                      : CANCEL,
                  ProjectStatus:
                    this.state.ideaItem.WorkflowStatus === "Approve" ||
                      this.state.ideaItem.WorkflowStatus === "Approved"
                      ? "Pending Documents"
                      : "NA",
                  Role: "Mentor",
                  updaterAction: "Approved",
                };
              } else {
                if (this.state.ideaItem.WorkflowStatus === AWAITING_MENTOR_APPROVAL_FOR_CANCELLATION) {
                  param = {
                    OnInitPageTime: this.state.onInitPageTime,
                    IdeaId: this.props.location.state,
                    ApprovalStatus: "NA",
                    UpdaterOHR: this.sessionData.profile.oHRId,
                    UpdaterEmail: this.sessionData.profile.oHRId + "@genpact.com",
                    UpdaterName:
                      this.sessionData.profile.lastName +
                      ", " +
                      this.sessionData.profile.firstName,
                    comment: this.state.Comment,
                    WorkflowStatus: "Pending",
                    RejectCancel: true,
                    Role: "Mentor",
                    updaterAction: "Discard Cancellation",
                  };
                } else {
                  param = {
                    OnInitPageTime: this.state.onInitPageTime,
                    IdeaId: this.props.location.state,
                    ApprovalStatus: "Pending Documents",
                    UpdaterOHR: this.sessionData.profile.oHRId,
                    UpdaterEmail: this.sessionData.profile.oHRId + "@genpact.com",
                    UpdaterName:
                      this.sessionData.profile.lastName +
                      ", " +
                      this.sessionData.profile.firstName,
                    comment: this.state.Comment,
                    WorkflowStatus: "Approve",
                    RejectCancel: true,
                    Role: "Mentor",
                    updaterAction: "Pending Documents",
                  };
                }
              }
            } else {
              this.state.businessImpactValueArray =
                this.state.businessImpactValueArray
                  .map((item) => ({
                    ...item,
                    pg_srno: item.SrNo,
                    dollarValue: item.DollarImpact,
                    fteValue: item.FTEImpact,
                  }))
                  .map((item) => {
                    return item;
                  });
              let filteredBIData = this.state.businessImpactValueArray.filter(
                function (e) {
                  return e !== null && e !== undefined;
                }
              );

              param = {
                OnInitPageTime: this.state.onInitPageTime,
                IdeaName: this.state.ideaItem.IdeaName,
                Problem: this.state.ideaItem.Problem,
                Solution: this.state.ideaItem.Solution,
                ServiceLineId: this.state.ideaItem.ServiceLineId,
                ServiceLineName: this.state.ideaItem.ServiceLineName,
                SubServiceLine: this.state.ideaItem.SubServiceLine,
                UpdaterOHR: this.sessionData.profile.oHRId,
                UpdaterEmail: this.sessionData.profile.oHRId + "@genpact.com",
                UpdaterName:
                  this.sessionData.profile.lastName +
                  ", " +
                  this.sessionData.profile.firstName,
                WorkflowStatusId:
                  this.state.workFlowStatusSelectedOption !== null
                    ? this.state.workFlowStatusSelectedOption.value
                    : null,
                WorkflowStatus:
                  this.state.workFlowStatusSelectedOption !== null
                    ? this.state.workFlowStatusSelectedOption.label
                    : null,
                ExpectedFinishDate:
                  this.state.workFlowStatusSelectedOption.label === "Approve"
                    ? new Date(this.state.expectedDate).toISOString()
                    : null,
                Comment: this.state.Comment,
                IdeaId: this.props.location.state,
                NewOrReplicatedIdea: this.state.ideaItem.NewOrReplicatedIdea,
                ReplicationProjectId: this.state.ideaItem.NewOrReplicatedIdea
                  ? this.state.ideaItem.ReplicationProjectId
                  : "",
                PotentialImpactDollar: this.state.ideaItem.PotentialImpactDollar,
                PotentialImpactFTE: this.state.ideaItem.PotentialImpactFTE,
                
                CertificationLevelName: this.state.certLevelsSelectedOption?.label,
                CertificationLevelId:this.state.certLevelsSelectedOption?.value,
                CertificationWorkTypeName:this.state.certWorkTypeSelectedOption?.value,
                
                TLID: this.state.transSelectedOption?.value,
                TransformationLeverName:this.state.transSelectedOption?.label,
                
                DigitalProjectType: this.state.digitalProjectTypeSelectedOptions?.label,
                DPTypeID:this.state.digitalProjectTypeSelectedOptions?.value,

                MethodologyTypeID: selectedValues,
                MethodologyName: selectedLabels,
                
                AIClassification: this.state.showAdditionalDetails && this.state.aiClassificationListSelectedOption !== null ? this.state.aiClassificationListSelectedOption.label : null,
                AIClassificationId: this.state.showAdditionalDetails && this.state.aiClassificationListSelectedOption !== null ? this.state.aiClassificationListSelectedOption.value : null,

                OtherTools: this.state.OtherTools,

                LDTId: this.state.LDTLeadSelectedOption?.value,
                LDTName: this.state.LDTLeadSelectedOption?.label,

                IsReplicationVerified: this.state.ideaItem.IsReplicationVerified,
                IsDigital:this.state.transSelectedOption?.label === "Digital" ? true : false,
                BusinessImpactData: filteredBIData,
                
                DataBridgeTheme: this.state.dataBridgeProjectTheme,
                SubCampaignName: this.state.subCampaignOption?.label,
                SubCampaignID: this.state.subCampaignOption?.value,

                CampaignID:this.state.campaignSelectedOption?.value,
                CampaignName: this.state.campaignSelectedOption?.label,
                MBBOHR: Number(this.state.mbbOHR),
                MBBName: this.state.mbbName,
                Role: "Mentor",
                updaterAction: this.state.workFlowStatusSelectedOption
                  ? this.state.workFlowStatusSelectedOption.label === "Approve"
                    ? "Approved"
                    : this.state.workFlowStatusSelectedOption.label
                  : "",

                VDType: this.state.impactOptionSelected
                  ? this.state.impactOptionSelected.label
                  : this.state.ideaItem.VDType,
                FinalImpactDollar: this.state.finalImpactDollar
                  ? this.state.finalImpactDollar
                  : null,
                FinalImpactFTE: this.state.finalImpactFTE
                  ? this.state.finalImpactFTE
                  : null,
                FPnAOHRMonetization: this.state.FPnAOHRMonetization
                  ? this.state.FPnAOHRMonetization
                  : "",
                FPnANameMonetization: this.state.FPnAOHRMonetization
                  ? this.state.FPnANameMonetization
                  : "",
                SowID: this.state.SowID ? this.state.SowID : "",
                IsVDMonetizable: this.state.monetizableProjectSelectedOption
                  ? this.state.monetizableProjectSelectedOption.label
                  : "",
                MonetizationStatus: this.state.monetizationStatusSelectedOption
                  ? this.state.monetizationStatusSelectedOption.label
                  : "",

                // AI First 
                isAI: this.state.isAI,
                ApprovalStatus: ApprovalStatus,
                IsIdeaReplicable: this.state.IsIdeaReplicableSelectedOption ? this.state.IsIdeaReplicableSelectedOption.label === "Yes" ? 1 : 0 : "",
                IsSolnFeasible: this.state.solutionFeasibleSelectedOption ? this.state.solutionFeasibleSelectedOption.label === "Yes" ? 1 : 0 : "",
                SolnComplexity: this.state.solutionComplexitySelectedOption ? this.state.solutionComplexitySelectedOption.label : "",
                LinkBRD: this.state.AIBRD,
                AIReason: this.state.AIReason,


               

              };
            }
            console.log(param);
            const requestOptions = {
              method: "PUT",
              headers: {
                "Content-Type": "application/json",
                "Authorization": "Bearer " + this.accessToken,
              },
              body: JSON.stringify(param),
            };
            fetch(`${REVIEW_IDEA_URL}`, requestOptions)
              .then((response) => {
                // Code change by TR
                return response.json().then((data) => {
                  if (response.status === 409) {
                    Toast.fail("This Idea has been updated by another stakeholder. Please open the Idea again to view the latest details.", 5000);

                    setTimeout(() => {
                      window.location.href = "/review-page";
                    }, 5000);

                    return null;
                  }

                  return data;
                });
              })
              .then((data) => {
                if (!data) {
                  return;
                }
                // Code change by TR

                Toast.hide();
                Toast.success("Updated successfully.", 3000, () => {
                  // console.log(JSON.stringify(data));
                  // window.location = "/review-page?page=approval";
                  let redirectURL = "/review-page";
                  if (this.state.approvalPage) {
                    redirectURL =
                      redirectURL + "?page=" + this.state.approvalPage;
                  }
                  window.location = redirectURL;
                });
              });
          }
        }
      } else {
        if (!this.isExceedlimit) {
          Toast.fail(
            "Required fields are missing or have invalid values. Please correct and try again.",
            3000,
            () => { }
          );
        }
      }
      // Code change bh TR
    } else {  ////bug fix stakeholder changes 2
      Toast.info("Blackbelt was updated by Idea owner.", 3000, () => {
        window.location = "/review-page?page=approval"
      })
    }  //bug fix stakeholder changes 2
    // Code change bh TR

    return false;
  };

 

  handleProblemChange = (text) => {
    let ideaItem = this.state.ideaItem;
    ideaItem.Problem = text;
    this.setState({
      ideaItem,
    });
  };

  handleSolutionChange = (text) => {
    let ideaItem = this.state.ideaItem;
    ideaItem.Solution = text;
    this.setState({
      ideaItem,
    });
  };

  handleTranscriptProblemChange = (text) => {
    let ideaItem = this.state.ideaItem;
    if (text !== null && text !== undefined) {
      ideaItem.Problem = text;
      this.setState({
        ideaItem,
      });
    }
  };
  handleTranscriptSolutionChange = (text) => {
    let ideaItem = this.state.ideaItem;
    if (text !== null && text !== undefined) {
      ideaItem.Solution = text;
      this.setState({
        ideaItem,
      });
    }
  };
  toggleTranscriptFunction = (id) => {
    this.setState({ speechModal: !this.state.speechModal, modalIndex: id });
    if (id === 2) {
      // approval details comment
      if (this.state.Comment) {
        this.setState({ previousTextForSpeech: this.state.Comment }, () =>
          console.log(this.state.previousTextForSpeech)
        );
      } else {
        this.setState({ previousTextForSpeech: "" }, () =>
          console.log(this.state.previousTextForSpeech)
        );
      }
    }
    if (id === 10) {
      // request cancellation comment
      this.setState({ previousTextForSpeech: this.state.Comment }, () =>
        console.log(this.state.previousTextForSpeech)
      );
    }
    if (id === 11) {
      this.setState(
        { previousTextForSpeech: this.state.ideaItem.Problem },
        () => console.log(this.state.previousTextForSpeech)
      );
    }
    if (id === 12) {
      this.setState(
        { previousTextForSpeech: this.state.ideaItem.Solution },
        () => console.log(this.state.previousTextForSpeech)
      );
    }
  };

  closeModalFunction = () => {
    this.setState({ speechModal: false });
  };

  showHideDiv = () => {
    let ideaItem = this.state.ideaItem;
    ideaItem.NewOrReplicatedIdea = !ideaItem.NewOrReplicatedIdea;
    this.setState({
      ideaItem,
    });
  };

  showHideVerifyReplicationDiv = () => {
    let ideaItem = this.state.ideaItem;
    ideaItem.IsReplicationVerified = !ideaItem.IsReplicationVerified;
    this.setState({
      ideaItem,
    });
  };
  handleReplicationIdChange = (text) => {
    let ideaItem = this.state.ideaItem;
    ideaItem.ReplicationProjectId = text;
    this.setState({
      ideaArray: ideaItem,
      replicationIDValidated: false,
    });
  };

  renderStatusOptions = () => {
    let options = [];
    this.state.workFlowStatusList.filter((item) => {
      options.push({
        value: item.WorkflowStatusId,
        label: item.WorkflowStatusName,
      });
    })
    return options;
  };

  renderCancelRequestOption = () => {
    let options = [];
    this.state.cancelRequestOption.map((item) => {
      options.push({
        value: item.WorkflowStatusId,
        label: item.WorkflowStatusName,
      });
      return options;
    });
    return options;
  };

  renderLeadOptions = () => {
    let options = [];
    const uniqueLeadList = [
      ...new Map(
        this.state.leadNameList.map((item) => [item.pg_ohr, item])
      ).values(),
    ];

    uniqueLeadList.map((item) => {
      options.push({ value: item.pg_ohr, label: item.pg_username });
      return options;
    });
    return options;
  };

  handleAccountNameChange = (e) => {
    if (this.state.campaignSelectedOption?.label   === AIFIRST &&  this.state.isAI && this.state.isAI === "No" && e && e.label === "Approve") {
      if (window.confirm("You are overriding the decision from AI Analyzer. Please provide a justification in the comments section.")) {
        if (e.value === 1) {
          this.setState({ showAdditionalDetails: true }, () => { });
        } else {
          this.setState({ showAdditionalDetails: false }, () => { });
        }
        this.setState({
          workFlowStatusSelectedOption: {
            value: e.value,
            label: e.label,
          },
        },
          () => {
            if ( this.state.workFlowStatusSelectedOption.label === "Send Back" || this.state.workFlowStatusSelectedOption.label === "Reject") {
              this.setState({ certLevelsSelectedOption: null }, () => {});
              if (this.state.campaignSelectedOption?.label === AIFIRST) {
                this.setState({
                  IsIdeaReplicableSelectedOption: [],
                  solutionFeasibleSelectedOption: [],
                  solutionComplexitySelectedOption: [],
                })
              }
            }
          }
        );
      }
      else {
        this.setState({ workFlowStatusSelectedOption: [] }, () => {})
      }
    }
    else {
      if (e.value === 1) {
        this.setState({showAdditionalDetails: true,},() => { });
      } else {
        this.setState({showAdditionalDetails: false,});
      }
      this.setState({
        workFlowStatusSelectedOption: {
          value: e.value,
          label: e.label,
        },
      },
        () => {
          if ( this.state.workFlowStatusSelectedOption.label === "Send Back" ||  this.state.workFlowStatusSelectedOption.label === "Reject") {
            this.setState({ certLevelsSelectedOption: null }, () => { });
            if ( this.state.campaignSelectedOption?.label === AIFIRST) {
              this.setState({
                IsIdeaReplicableSelectedOption: [],
                solutionFeasibleSelectedOption: [],
                solutionComplexitySelectedOption: [],
              })
            }
          }
        }
      );
    }
  };

  handleCancelRequestChange = (e) => {
    this.setState({
      workFlowStatusSelectedOption: {
        value: e.value,
        label: e.label,
      },
    }, () => { });
  };

  handleLDTLeadOptionChange = (e) => {
    if (parseInt(e.value) === parseInt(this.state.ideaItem.OwnerOHR) || parseInt(e.value) === parseInt(this.state.ideaItem.CreatorOHR)) {
      Toast.fail("LDT user cannot be the same as Idea Owner/Requester. Please select a different LDT user.", 3000, () => { return; });
      return;
    }
    let styleStateObj = this.state.selectStyle;
    styleStateObj.LDTLeadSelectedOption = selectStyle(true);
    this.setState({
      selectStyle: styleStateObj,
      LDTLeadSelectedOption: {
        value: e.value,
        label: e.label,
      },
    });
  };

  handleMBBChange = (e) => {
    if (
      parseInt(e.value) === parseInt(this.state.ideaItem.OwnerOHR) ||
      parseInt(e.value) === parseInt(this.state.ideaItem.CreatorOHR)
    ) {
      Toast.fail(
        "Master Black Belt user cannot be the same as Idea Owner/Requester. Please select a different Master Black Belt user.",
        3000,
        () => {
          return;
        }
      );
      return;
    }
    let styleStateObj = this.state.selectStyle;
    styleStateObj.mbbUserName = selectStyle(true);
    this.setState({
      selectStyle: styleStateObj,
      mbbName: e.label,
      mbbOHR: e.value,
      mbbSelectedOption: {
        value: e.value,
        label: e.label,
      },
    });
  };

  // Code change bh TR - sugg by AB

  renderMBBOptions = () => {

    let options = [];
    let result = [];
    this.state.mbbList.map((item) => {
      const userRole = JSON.parse(item.pg_Role).pg_role;
      if (userRole === "MBB") {
        if (this.state.ideaItem.OwnerOHR !== item.pg_ohr) {
          options.push({ value: item.pg_ohr, label: item.pg_username });
        }
      }
      return true;
    });
    result = options.reduce((unique, index) => {
      if (!unique.some(obj => obj.label === index.label && obj.value === index.value)) {
        unique.push(index);
      }
      return unique;
    }, []);
    return result;
  };
  // Code change bh TR - sugg by AB


  renderCertLevelsOptions = () => {
    let options = [];
    this.state.certificationLevelsList.map((item) => {
      options.push({
        value: item.CertificationLevelId,
        label: item.CertificationLevelName,
      });
      return options;
    });
    //this.state.isQAUser
    return options;
  };

  handleCertLevelChange = (e) => {
    let styleStateObj = this.state.selectStyle;
    styleStateObj.certLevelsSelectedOption = selectStyle(true);
    this.setState(
      {
        certLevelsSelectedOption: e,
        selectStyle: styleStateObj,
        certWorkTypeSelectedOption: null,
        digitalProjectTypeSelectedOptions: null,
        transSelectedOption: null,
        digitalProjectEnabled: false,
        aiClassificationListSelectedOption: null,
        methodologySelectedOptions: null,
        OtherTools: "",
        workTypeEnabled: false,
        displayWorkType: false
      }, () => {
        if (e && e.label === "GB") {
          if (this.state.isQAUser) {
            Toast.fail("As a QA you can only approve Lean Projects. If this Idea needs to be approved as GB, please delegate the this Idea to a Black Belt.", 7000, () => { })
            this.setState({
              certLevelsSelectedOption: null,
              certWorkTypeSelectedOption: null,
              digitalProjectTypeSelectedOptions: null,
              transSelectedOption: null,
              digitalProjectEnabled: false,
              methodologySelectedOptions: null,
              OtherTools: ""
            })
            return;
          }
        }
      }
    );
    if (this.state.campaignSelectedOption) {
      if (this.state.campaignSelectedOption.label === "Data Bridge" || this.state.campaignSelectedOption.label === "AI First"  || this.state.campaignSelectedOption.label === "Gen AI") {
        if (e && e.label === "GB") {
          this.setState({
            workTypeEnabled: false,
            displayWorkType: true,
            certWorkTypeSelectedOption: { value: "GB ProDG", label: "GB ProDG" },
            digitalProjectTypeSelectedOptions: null,
            digitalProjectEnabled: false
          })
        }
      }
    }

  };

  renderCertWorkTypeOptions = (e) => {
    let options = [];
    this.state.certificationWorkTypeList.map((item) => {
      if (e && e.label === item.CertifiationLevelName) {
        options.push({
          value: item.WorkTypeName,
          label: item.WorkTypeName,
        });
      }
      return options;
    });
    return options;
  };

  handleCertWorkTypeChange = (e) => {
    this.setState(
      {
        certWorkTypeSelectedOption: {
          value: e.value,
          label: e.label,
        },
        aiClassificationListSelectedOption: null
      },
      () => { }
    );

  };

  renderTransLeversOptions = () => {
    // let options = [];
    // this.state.transformationLeversList && this.state.transformationLeversList.map((item) => {
    //   if (item.CampaignID === this.state.campaignSelectedOption?.value) {
    //     options.push({
    //       value: item.RecID,
    //       label: item.TransformationLever,
    //     });
    //   }
    // })
    // return options;
    let options = [];
    let result = [];
    this.state.campaignUnionQuery && this.state.campaignUnionQuery.map((item) => {
      if (this.state.campaignSelectedOption?.value === item.CampaignID) {
        options.push({ value: item.TLID, label: item.TransformationLever, SOrd: item.TLOrd });
      }
      return true;
    });
    result = options.reduce((unique, index) => {
      if (!unique.some(obj => obj.label === index.label && obj.value === index.value)) {
        unique.push(index);
      }
      return unique;
    }, []);
    result.sort((a, b) => a.SOrd - b.SOrd);
    return result

  };

  handleTransLeversChange = (e) => {
    let styleStateObj = this.state.selectStyle;
    styleStateObj.transSelectedOption = selectStyle(true);
    this.setState({
      transSelectedOption: e,
      selectStyle: styleStateObj,
      digitalProjectTypeSelectedOptions: null,
      certWorkTypeSelectedOption: null,
      digitalProjectEnabled: false,
      aiClassificationListSelectedOption: null,
      methodologySelectedOptions: null,
      OtherTools: "",
      workTypeEnabled: false,
      displayWorkType: false
    });

    if (e.label === "Digital") {
      this.renderDigitalProjectTypeOptions();
      this.setState({
        digitalProjectEnabled: true,
      });
    }

    if (this.state.certLevelsSelectedOption && this.state.certLevelsSelectedOption.label === "GB") {
      if (e.label === "Continuous Improvement") {
        this.setState({ workTypeEnabled: true, displayWorkType: false }, () => { });
      } else {
        this.setState({ workTypeEnabled: false, displayWorkType: true, certWorkTypeSelectedOption: { value: "GB ProDG", label: "GB ProDG" }, }, () => { });
      }
    }

  };

  renderMethodologyOptions = () => {
    let options = [];
    this.state.methodologyList && this.state.methodologyList.map((item, ind) => {
      if (this.state.transSelectedOption && this.state.transSelectedOption.label === item.TransformationLever && this.state.aiClassificationListSelectedOption?.label === item.AIClassification) {
        if (this.state.digitalProjectTypeSelectedOptions) {
          if (this.state.digitalProjectTypeSelectedOptions.label === item.DigitalProjectType) {
            options.push({
              value: item.RecID,
              label: item.Methodology,
              sortOrder: item.SOrd || 0
            })
          }
        }
        else {
          options.push({
            value: item.RecID,
            label: item.Methodology,
            sortOrder: item.SOrd || 0
          })
        }
      }
    })
    options.sort((a, b) => a.sortOrder - b.sortOrder);
    // console.log("mehtodologies length =>", options.length)
    return options.map(({ value, label }) => ({ value, label }));;
  };

  handleMethodologyChange = (e) => {
    if (e.length <= 10) {
      let styleStateObj = this.state.selectStyle;
      styleStateObj.methodologySelectedOptions = selectStyle(true);
      this.setState({ methodologySelectedOptions: e, selectStyle: styleStateObj, OtherTools: "" }, () => { });
    } else {
      window.alert("You can add upto 10 tools/methodologies options only.")
      return false;
    }
    // this.setState({
    //   methodologySelectedOptions: {
    //     value: e.value,
    //     label: e.label,
    //   }, selectStyle: styleStateObj,
    // });
  };

  handleOtherToolsChange = (e) => {
    let nonWhiteSpace = e.replace(/^\s+|\s+$/gm, '');
    let styleStateObj = this.state.selectStyle;
    styleStateObj.OtherTools = textBoxValidation(true);
    if (nonWhiteSpace.length <= 300) {
      this.setState({ OtherTools: e, selectStyle: styleStateObj, }, () => { })
    } else {
      const trimmedValue = nonWhiteSpace.slice(0, 300);
      this.setState({ OtherTools: trimmedValue }, () => { });
    }
  }

  renderDataBridgeThemeOptions = () => {
    let options = [];
    this.state.databridgeThemeList.map((item) => {
      options.push({
        value: item.ThemeId,
        label: item.DBProjectThemeName,
      });
      return options;
    });
    return options;
  };

  renderDigitalProjectTypeOptions = () => {

    // let options = [];
    // let filteredData = this.state.digitalProjectTypeList && this.state.digitalProjectTypeList.filter((item)=>{
    //   return item.TLID === this.state.transSelectedOption?.value;
    // })
    
    // filteredData.map((item) => {
    //   let skipOption = false;
    //   if (this.state.certLevelsSelectedOption?.label === "Lean") {
    //     if (item.DPType === "RPA") {
    //       skipOption = true;
    //     }
    //   }
    //   if (!skipOption) {
    //     options.push({
    //       value: item.RecID,
    //       label: item.DPType,
    //     });
    //   }
    //   return options;
    // });
    // return options;


    let options = [];
    let result = [];
    this.state.campaignUnionQuery && this.state.campaignUnionQuery.map((item) => {
      if (item.DPType) {
        if (this.state.campaignSelectedOption?.value === item.CampaignID) {
          if (this.state.transSelectedOption?.value === item.TLID) {
            if (this.state.certLevelsSelectedOption?.label === "Lean") {
              if (item.DPType !== "RPA") {
                options.push({ value: item.DPTypeID, label: item.DPType, SOrd:item.DPOrder });
              }
            } else {
              options.push({ value: item.DPTypeID, label: item.DPType ,SOrd:item.DPOrder});
            }
          }
        }
      }
      return true;
    });
    result = options.reduce((unique, index) => {
      if (!unique.some(obj => obj.label === index.label && obj.value === index.value)) {
        unique.push(index);
      }
      return unique;
    }, []);

    result.sort((a,b)=> a.SOrd - b.SOrd)
    return result
  };

  handleDigitalProjectTypeChange = (e) => {
    console.log("digital project selected option =>",e)
    let styleStateObj = this.state.selectStyle;
    styleStateObj.digitalProjectTypeSelectedOptions = selectStyle(true);
    this.setState({
      selectStyle: styleStateObj,
      digitalProjectTypeSelectedOptions: {
        value: e.value,
        label: e.label,
      },
      methodologySelectedOptions: null,
      aiClassificationListSelectedOption: null,
      OtherTools: "",
    });
  };

  renderServiceLineOptions = () => {
    let options = [];
    const uniqueServiceLineList = [
      ...new Map(
        this.state.serviceLineList.map((item) => [item.ServiceLineName, item])
      ).values(),
    ];
    uniqueServiceLineList.map((item) => {
      options.push({ value: item.ServiceLineId, label: item.ServiceLineName });
      return true;
    });
    return options;
  };

  renderSubServiceLineOptions = () => {
    let options = [];

    this.state.subServiceLineList.map((item) => {
      if (this.state.ideaItem.ServiceLineName === item.ServiceLineName) {
        options.push({
          value: item.SubServiceLineId,
          label: item.SubServiceLineName,
        });
        return true;
      }
      return true;
    });
    return options;
  };

  renderSubCampaignOptions = () => {
    if (this.state.campaignSelectedOption?.label === "Gen AI") {
      return GENAIOPTIONS;
    } else {
      let options = [];
      let result = [];
      this.state.campaignUnionQuery && this.state.campaignUnionQuery.map((item) => {
        if (this.state.campaignSelectedOption?.value === item.CampaignID) {
          options.push({ value: item.SubCampaignID, label: item.SubCampaign, SOrd:item.SubCampaignOrd });
        }
        return true;
      });
      result = options.reduce((unique, index) => {
        if (!unique.some(obj => obj.label === index.label && obj.value === index.value)) {
          unique.push(index);
        }
        return unique;
      }, []);
      result.sort((a,b)=> a.SOrd - b.SOrd)
      return result
    }
  };

  renderServiceLineOptions = () => {
    let options = [];
    const uniqueServiceLineList = [
      ...new Map(
        this.state.serviceLineList.map((item) => [item.ServiceLineName, item])
      ).values(),
    ];
    uniqueServiceLineList.map((item) => {
      options.push({ value: item.ServiceLineId, label: item.ServiceLineName });
      return true;
    });
    return options;
  };

  handleDataBridgeProjectThemeChange = (e) => {
    let styleStateObj = this.state.selectStyle;
    styleStateObj.dataBridgeProjectTheme = selectStyle(true);
    this.setState({
      selectStyle: styleStateObj,
      dataBridgeProjectTheme: e.label,
      databridgeThemeSelectedOptions: {
        value: e.label,
        label: e.label,
      },
    });
  };

  handleSubCampaignChange = (e) => {
    let styleStateObj = this.state.selectStyle;
    styleStateObj.subCampaignOption = selectStyle(true);
    this.setState({
      selectStyle: styleStateObj,
      subCampaignOption: e,
    },()=>{ });
  };

  handleServiceLineChange = (e) => {
    let ideaItem = this.state.ideaItem;
    ideaItem.ServiceLineId = e.value;
    ideaItem.ServiceLineName = e.label;
    ideaItem.SubServiceLineId = "";
    ideaItem.SubServiceLine = "";
    this.setState({
      subServiceLineSelectedOption: null,
      serviceLineSelectedOption: {
        value: e.value,
        label: e.label,
      },
      ideaItem,
    });
    this.renderSubServiceLineOptions(e);
  };

  handleSubServiceLineChange = (e, index) => {
    let ideaItem = this.state.ideaItem;
    ideaItem.SubServiceLine = e.label;
    this.setState({
      subServiceLineSelectedOption: {
        value: e.value,
        label: e.label,
      },
      ideaItem,
    });
  };

  fetchReplicationIdeaDetails = async (IdeaId) => {
    try {
      Toast.loading("Fetching Replication Idea Details. Please wait...", () => { });
      const requestOptions = {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
          "Authorization": "Bearer " + this.accessToken,
        },
      };
      const response = await fetch(`${GET_IDEA_URL}&IdeaId=${this.state.ideaItem.IdeaId}&IdeaIDAlpha=${IdeaId}&case=data&casetype=fetchIdeaDetails`, requestOptions)
      if (response.ok) {
        const data = await response.json()
        if (data) {
          if (data.ResultSets.Table1 === undefined) {
            Toast.fail(
              "We could not find the Idea based on the entered replication Idea ID. Please check and re-enter.",
              5000,
              () => { }
            );
            let ideaItem = this.state.ideaItem;
            ideaItem.ReplicationProjectId = "";
            this.setState({
              ideaItem,
              replicationIDValidated: false,
            });
            return false;
          } else {
            Toast.hide();
            let ideaItem = this.state.ideaItem;
            ideaItem.ReplicationProjectId = IdeaId;
            let styleStateObj = this.state.selectStyle;
            styleStateObj.ReplicationProjectId = {
              ...textBoxValidation(true),
              border: "1px solid lightgrey",
            };
            this.setState({
              ideaItem,
              selectStyle: styleStateObj,
            });
            Toast.success(
              "Replication Idea ID validated successfully!",
              3000,
              () => { }
            );
            return true;
          }

        }
      }

    } catch (err) {
      Toast.hide();
      Toast.fail("We could not find the Idea based on the entered replication Idea ID. Please check and re-enter.",5000, () => { });
      let ideaItem = this.state.ideaItem;
      ideaItem.ReplicationProjectId = "";
      this.setState({
        ideaItem,
        replicationIDValidated: false,
      });
      return false;

    }


  };

  validateReplicationId = (ideaId) => {
    if (!this.fetchReplicationIdeaDetails(ideaId)) {
      let ideaItem = this.state.ideaItem;
      ideaItem.ReplicationProjectId = "";
      this.setState({
        ideaItem,
        replicationIDValidated: false,
      });
      return false;
    } else {
      let ideaItem = this.state.ideaItem;
      ideaItem.ReplicationProjectId = ideaId;
      this.setState({
        ideaItem,
        replicationIDValidated: true,
      });
      return true;
    }
  };

  cancelEvent = () => {
    // this.props.history.push("/review-page?page=approval");
    let redirectURL = "/review-page";
    if (this.state.approvalPage) {
      // redirectURL = redirectURL + "?page=" + this.state.approvalPage;
      // this.props.history.push(redirectURL);
      this.props.history.push({
        pathname: redirectURL,
        search: "?page=" + this.state.approvalPage,
        propsList: this.state.propsData,
      });
    } else {
      this.props.history.push(redirectURL);
    }
  };

  renderCampaignOptions = () => {
    let options = [];
    let result = [];
    let filteredData = this.state.campaignUnionQuery && this.state.campaignUnionQuery.filter((item)=>{return item.Campaign !== "AI First"})
    filteredData && filteredData.map((item) => {
      options.push({ value: item.CampaignID, label: item.Campaign, SOrd:item.CampaignOrd });
      return true;
    });
    result = options.reduce((unique, index) => {
      if (!unique.some(obj => obj.label === index.label && obj.value === index.value)) {
        unique.push(index);
      }
      return unique;
    }, []);
    result.sort((a,b)=> a.SOrd - b.SOrd)
    return result
  };

  handleCampaignNameChange = (e) => {
    let styleStateObj = this.state.selectStyle;
    styleStateObj.campaignSelectedOption = selectStyle(true);
    this.setState({
      IsIdeaReplicableSelectedOption: [],
      solutionFeasibleSelectedOption: [],
      solutionComplexitySelectedOption: [],
      dataBridgeProjectTheme: "",
      subCampaignOption: null,
      selectStyle: styleStateObj,
      campaignSelectedOption: e,
      transSelectedOption:null,
      aiClassificationListSelectedOption: null,
      methodologySelectedOptions: null,
      digitalProjectTypeSelectedOptions: null,
      OtherTools: "",
    },()=>{});

    // below code will check the union query and will set subcampaign to true if the union query contains the subcampaign query
    let options = [];
    let result = [];
    this.state.campaignUnionQuery && this.state.campaignUnionQuery.map((item) => {
      if (e.value === item.CampaignID) {
        this.setState({ campaignInsight: item.CampaignDescr }, () => { })
        if(item.SubCampaign){
          options.push({ value: item.SubCampaignID, label: item.SubCampaign });
        }
      }
      return true;
    });
    result = options.reduce((unique, index) => {
      if (!unique.some(obj => obj.label === index.label && obj.value === index.value)) {
        unique.push(index);
      }
      return unique;
    }, []);

    if(result.length>0){
      this.setState({ displaySubCampaign: true }, () => {})
    }else{
      this.setState({ displaySubCampaign: false }, () => {})
    }
    
  };

  formatDateStringWithTime(dateparam) {
    return dateparam.toLocaleDateString("en-GB", {
      year: "numeric",
      month: "2-digit",
      day: "2-digit",
      hour: "2-digit",
      minute: "2-digit",
      second: "2-digit",
    });
  }

  
  

  addMonetizableValues = (e) => {
    let MonetizedBiArray = [];
    let fteValue = 0;
    let dollarValue = 0;
    this.state.businessImpactValueArray.filter((item) => {
      if (item.IsMonetized === "Yes") {
        MonetizedBiArray.push(item);
      }
    });
    if (MonetizedBiArray) {
      const groupedData = MonetizedBiArray.reduce(
        (accumulator, currentValue) => {
          const impactType = currentValue.impactType;
          const fteValue = parseFloat(currentValue.fteValue) || 0.0;
          const dollarValue = parseFloat(currentValue.dollarValue) || 0.0;
          const existingRow = accumulator.find(
            (row) => row.impactType === impactType
          );
          if (existingRow) {
            existingRow.fteValue += fteValue;
            existingRow.dollarValue += dollarValue;
          } else {
            accumulator.push({ impactType, fteValue, dollarValue });
          }
          return accumulator;
        },
        []
      );
      // console.log("grouped data",groupedData)

      if (groupedData.length === 0) {
        fteValue = 0;
        dollarValue = 0;
      } else {
        fteValue = groupedData[0].fteValue;
        dollarValue = groupedData[0].dollarValue;
      }
      this.setState(
        {
          totalMonetizedFTE: fteValue,
          totalMonetizedDollar: dollarValue,
        },
        () => { }
      );
    }
  };
  newBusinessImpactSummary() {
    let myArray = [...this.state.businessImpactValueArray];
    const groupedData = myArray.reduce((accumulator, currentValue) => {
      const impactType = currentValue.impactType;
      const monetizableType = currentValue.monetizableType;
      const fteValue = parseFloat(currentValue.fteValue) || 0.0;
      const dollarValue = parseFloat(currentValue.dollarValue) || 0.0;

      const existingRow = accumulator.find(
        (row) =>
          row.impactType === impactType &&
          row.monetizableType === monetizableType
      );
      if (existingRow) {
        existingRow.fteValue += fteValue;
        existingRow.dollarValue += dollarValue;
      } else {
        accumulator.push({
          impactType,
          monetizableType,
          fteValue,
          dollarValue,
        });
      }
      return accumulator;
    }, []);
    this.setState({ summaryArray: groupedData }, () => { });
    this.addMonetizableValues();
  }
  pull_data = (businessImpactValueArray) => {
    if (businessImpactValueArray) {
      this.setState(
        { businessImpactValueArray: businessImpactValueArray },
        () => {
          this.newBusinessImpactSummary();
          let dollarTotal = 0.0;
          let fteValue = 0.0;
          this.state.businessImpactValueArray.map((item) => {
            if (item && item.DollarImpact) {
              dollarTotal += parseFloat(item.DollarImpact);
            }
            if (item && item.dollarValue) {
              dollarTotal += parseFloat(item.dollarValue);
            }
            if (item && item.FTEImpact) {
              fteValue += parseFloat(item.FTEImpact);
            }
            if (item && item.fteValue) {
              fteValue += parseFloat(item.fteValue);
            }
          });
          this.setState({ finalImpactDollar: dollarTotal }, () => {
            console.log("inside call back function $ total",this.state.finalImpactDollar)
          });
          this.setState({ finalImpactFTE: fteValue }, () => {
            console.log("inside call back function fte value",this.state.finalImpactFTE)
          });
        },
        () => {
          console.log("from pull data function",this.state.businessImpactValueArray)
        }
      );
    }
  };
  pull_file_data = ({
    fileName,
    fileType,
    fileContent,
    showClientApprovalFields,
    FPnAOHRMonetization,
  }) => {
    if (fileName) {
      this.setState({ FPnAFileNameMonetization: fileName }, () => { });
    }
    if (fileType) {
      this.setState({ FPnAFileTypeMonetization: fileType }, () => { });
    }
    if (fileContent) {
      this.setState({ FPnAFileMonetization: fileContent }, () => { });
    }
    this.setState(
      { showClientApprovalFields: showClientApprovalFields },
      () => { }
    );
    this.setState({ FPnAOHRMonetization: FPnAOHRMonetization }, () => {
      //console.log("ohr from pull_file_data function =>",this.state.FPnAOHRMonetization)
    });
  };
  remove_bi_data_after_delete = (filteredIdeaArray) => {
    //console.log("bi recieved in pull data for delete function",filteredIdeaArray)
    if (filteredIdeaArray) {
      this.setState({ businessImpactValueArray: filteredIdeaArray }, () => {
        this.newBusinessImpactSummary();
        let dollarTotal = 0.0;
        let fteValue = 0.0;
        this.state.businessImpactValueArray.map((item) => {
          if (item && item.DollarImpact) {
            dollarTotal += parseFloat(item.DollarImpact);
          }
          if (item && item.dollarValue) {
            dollarTotal += parseFloat(item.dollarValue);
          }
          if (item && item.FTEImpact) {
            fteValue += parseFloat(item.FTEImpact);
          }
          if (item && item.fteValue) {
            fteValue += parseFloat(item.fteValue);
          }
        });
        this.setState({ finalImpactDollar: dollarTotal }, () => {
          // console.log("inside call back function $ total",this.state.finalImpactDollar)
        });
        this.setState({ finalImpactFTE: fteValue }, () => {
          // console.log("inside call back function fte value",this.state.finalImpactFTE)
        });
      });
    }
  };

  pull_monetization_sowId = (localSowId) => {
    this.setState({ SowID: localSowId }, () => {
      //console.log("sow id from pull_monetization_sowId function =>",this.state.SowID)
    });
  };
  pull_monetization_fpna_name = (localFpnaName) => {
    //console.log("fpna name from pull file function => ",localFpnaName)
    this.setState({ FPnANameMonetization: localFpnaName }, () => {
      //console.log("fpna name from pull_file_function",this.state.FPnANameMonetization)
    });
  };
  pull_monetization_fpna_ohr = (localFpnaohr) => {
    //console.log("fpna ohr from pull function => ",localFpnaohr)
    this.setState({ FPnAOHRMonetization: localFpnaohr }, () => { });
  };
  pull_monetizedTotal = ({ fteValue, dollarValue }) => {
    if (fteValue) {
      this.setState({ totalMonetizedDollar: fteValue }, () => {
        //console.log(this.state.totalMonetizedDollar)
      });
    }
    if (dollarValue) {
      this.setState({ totalMonetizedFTE: dollarValue }, () => {
        //console.log(this.state.totalMonetizedFTE)
      });
    }
  };
  pull_monetizableProject = (e) => {
    if (e) {
      this.setState({ monetizableProjectSelectedOption: e }, () => {
        console.log("monetization project Option =>", this.state.monetizableProjectSelectedOption)
      });
    }
  };
  pull_monetizableStatus = (e) => {
    if (e) {
      this.setState({ monetizationStatusSelectedOption: e }, () => {
        console.log("monetization Status SelectedOption =>", this.state.monetizationStatusSelectedOption)
      });
    }
  };

  handleVDTypeChange = (e) => {
    if (e) {
      this.setState({ impactOptionSelected: e }, () => {
        console.log("impact selected option is from review idea page",this.state.impactOptionSelected)
        if (this.state.impactOptionSelected.label === NO_VD) {
          this.setState(
            {
              showClientFields: false,
              showGOLFields: false,
              finalImpactDollar: 0,
              monetizableProjectSelectedOption: null,
              monetizationStatusSelectedOption: null,
              showClientApprovalFields: false,
            },
            () => { }
          );
        }
        if (
          this.state.impactOptionSelected.label === VD_TO_CLIENT
        ) {
          this.setState(
            { showClientFields: true, showGOLFields: false },
            () => { }
          );
        }
        if (
          this.state.impactOptionSelected.label === VD_TO_GENPACT
        ) {
          this.setState({ showClientFields: false, showGOLFields: true });
        }
        if (
          this.state.impactOptionSelected.label ===
          VD_TO_CLIENT_PLUS_GENPACT
        ) {
          this.setState({ showClientFields: true, showGOLFields: true });
        }
      });
    }
  };
  fetchFPAOHRforIncreaseInRevenue = (e) => {
    if (e === true) {
      this.setState({ appropriateAttachment: true }, () => { });
    } else {
      this.setState({ appropriateAttachment: false }, () => { });
    }
  };

  pullMonetizationGOLName = (localGOLName) => {
    this.setState({ golMonetizationName: localGOLName }, () => {
      //console.log(this.state.golMonetizationName)
    });
  };
  pullMonetizationGOLOhr = (localGOLOhr) => {
    this.setState({ golMonetizationOhr: localGOLOhr }, () => {
      //console.log(this.state.golMonetizationOhr)
    });
  };
  pullCategoryNotListed = (localShowHref) => {
    this.setState({ showHrefModal: localShowHref }, () => {
      console.log("hrf modal =>", this.state.showHrefModal)
    });
  };


  // function for FPNAGOL component starts here

  // ppt deck file details
  pullPPTDeck = () => { }

  // client approval details
  pullClientName = (e) => { }
  pullClientRole = (e) => { }
  pullClientSignOff = (e) => { }
  pullClientDocName = () => { }
  pullClientDocType = () => { }
  pullClientDocContent = () => { }

  // gol approval details
  pullGolName = () => { }
  pullGolOhr = () => { }
  pullgolFileName = () => { }
  pullgolFileType = () => { }
  pullgolContent = () => { }

  // fpna approval fetch details
  pullFpnaOhr = () => { }
  pullFpnaName = () => { }
  pullfpnafileName = () => { }
  pullfpnafileType = () => { }
  pullfpnafileContent = () => { }
  pull_fileDetails = () => { }
  pull_monetization_fpna_ohr = () => { }
  pullCategoryNotListed = () => { };
  pullMonetizationGOLOhr = () => { }
  pullMonetizationGOLName = () => { }
  // function for FPNAGOL component ends here

  getStatus = () => {
    const { logAction, ideaItem } = this.state;
    if (this.state.ideaItem.WorkflowStatus) {
      if (this.state.ideaItem.WorkflowStatus === "Approve") {
        return "";
      }
      if (this.state.ideaItem.WorkflowStatus === "Reject") {
        return "REJECTED";
      }

      if (this.state.ideaItem.WorkflowStatus === "Send Back") {
        return "SENT_BACK";
      }
      if (
        this.state.ideaItem.WorkflowStatus === CANCEL ||
        this.state.ideaItem.ApprovalStatus === CANCEL
      ) {
        return CANCEL;
      }
      if (
        this.state.ideaItem.WorkflowStatus === AWAITING_MENTOR_APPROVAL_FOR_CANCELLATION ||
        this.state.ideaItem.ApprovalStatus === AWAITING_MENTOR_APPROVAL_FOR_CANCELLATION
      ) {
        return AWAITING_MENTOR_APPROVAL_FOR_CANCELLATION;
      }
    }
    if (logAction === "Approve") {
      return APPROVED;
    }
    if (logAction === "Send Back") {
      return SENT_BACK;
    }
    if (logAction === "Reject") {
      return REJECTED;
    }
    if (logAction === AWAITING_MENTOR_APPROVAL_FOR_CANCELLATION) {
      return AWAITING_MENTOR_APPROVAL_FOR_CANCELLATION;
    }
    if (logAction === "Pending") {
      return "Pending";
    }
    if (this.state.ideaItem.WorkflowStatus === "Pending") {
      if (logAction === "Delegate Action") {
        return "Delegated";
      }
      return "Pending";
    }

    if (ideaItem.Comment !== null) {
      if (logAction === "Idea Reinitiated by Admin") {
        return "Idea Reinitiated";
      } else {
        return "Discard Cancellation";
      }
    }
    //return "PENDING";
  };

  handleIsIdeaReplicableChange = (e) => {
    console.log(e)
    let styleStateObj = this.state.selectStyle;
    styleStateObj.IsIdeaReplicableSelectedOption = selectStyle(true);
    this.setState({ selectStyle: styleStateObj, IsIdeaReplicableSelectedOption: e }, () => {
      console.log("on changee", this.state.IsIdeaReplicableSelectedOption)
    })
  };

  handleSolutionFeasibleChange = (e) => {
    let styleStateObj = this.state.selectStyle;
    styleStateObj.solutionFeasibleSelectedOption = selectStyle(true);
    this.setState({ selectStyle: styleStateObj, solutionFeasibleSelectedOption: e })
  };
  handleSolutionComplexityChange = (e) => {
    let styleStateObj = this.state.selectStyle;
    styleStateObj.solutionComplexitySelectedOption = selectStyle(true);
    this.setState({ selectStyle: styleStateObj, solutionComplexitySelectedOption: e })
  };





  handleAIDocumentClick = (link) => {
    window.open(link, "_blank");
  }



  handleAIClassificationList = (e) => {
    let styleStateObj = this.state.selectStyle;
    styleStateObj.aiClassificationListSelectedOption = selectStyle(true);
    this.setState({
      selectStyle: styleStateObj,
      aiClassificationListSelectedOption: {
        value: e.value,
        label: e.label,
      },
      methodologySelectedOptions: null,
      OtherTools: "",
    }, () => {
    }
    );
  }

  renderAIClassificationList = () => {
    let options = [];
    if (this.state.transSelectedOption) {
      if (this.state.digitalProjectTypeSelectedOptions) {
        this.state.aiClassificationList && this.state.aiClassificationList.map((item) => {
          if (item.TransformationLever === "Digital" && this.state.transSelectedOption?.label === "Digital") {
            if (item.DigitalProjectType === this.state.digitalProjectTypeSelectedOptions.label) {
              options.push({
                value: item.RecID,
                label: item.AIClassification
              })
            }
          }
        })
      }
      else {
        this.state.aiClassificationList && this.state.aiClassificationList.map((item) => {
          if (item.DigitalProjectType === null && item.TransformationLever === this.state.transSelectedOption.label) {
            if(this.state.campaignSelectedOption?.label === "Gen AI"){
              if(item.AIClassification === "Gen AI"){
                options.push({
                  value: item.RecID,
                  label: item.AIClassification
                })
              }
            }else{
              options.push({
                value: item.RecID,
                label: item.AIClassification
              })
            }
          }
        })
      }
    }
    // console.log("AI classification options =>",options && options.length)
    return options;
  }




  render() {
    // this is for idea approval details -> Idea approval status
    this.state.ideaApprovalStatus = this.getStatus();
    // console.log(this.state.ideaApprovalStatus);

    let IDEA_APPROVED = this.state.ideaItem.WorkflowStatus === "Approve";
    let IDEA_REJECTED = this.state.ideaItem.WorkflowStatus === "Reject";
    let IDEA_SEND_BACK = this.state.ideaItem.WorkflowStatus === "Send Back";
    let IDEA_REQUEST_CANCELLATION =
      this.state.ideaItem.WorkflowStatus === AWAITING_MENTOR_APPROVAL_FOR_CANCELLATION;
    let IDEA_REQUEST_CANCELLATION1 =
      this.state.ideaItem.ApprovalStatus === AWAITING_MENTOR_APPROVAL_FOR_CANCELLATION;

    
    let IDEA_UPDATERACTION = this.state.ideaItem.updaterAction;






    return (
      <>
        <section className="u-clearfix u-section-1" id="sec-0f7f">
          <div
            className="u-clearfix u-sheet u-sheet-1"
            style={{ marginBottom: 20 }}
          >
            <div className="u-align-left u-border-3 u-border-white u-container-style u-expanded-width u-group u-radius-10 u-shape-round u-white u-group-1">
              <div className="u-container-layout u-container-layout-1">
                <h4
                  style={{
                    textAlign: "center",
                    color: "#00AECF",
                    fontFamily: "Arial",
                    fontSize: 22,
                  }}
                >
                  Review idea :{" "}
                  {this.state.ideaItem.IdeaIDAlpha
                    ? this.state.ideaItem.IdeaIDAlpha
                    : this.state.ideaItem.IdeaId}{" "}
                </h4>
                <div className="u-align-left u-container-style u-expanded-width u-group u-shape-rectangle u-group-2">
                  <div
                    className="u-container-layout u-container-layout-2"
                    style={{ textAlign: "center" }}
                  >
                    <div className="u-border-1 u-border-palette-5-base u-container-style u-group u-radius-6 u-shape-round u-group-3">
                      <div className="u-container-layout u-container-layout-3">
                        <p
                          className="u-align-left u-text u-text-2"
                          style={{ marginBottom: 13 }}
                        >
                          Owner details
                        </p>
                        <div className="row">
                          <div className="col-md-5">
                            <label
                              style={{
                                verticalAlign: "bottom",
                                marginBottom: -5,
                              }}
                            >
                              Owner OHR
                            </label>{" "}
                          </div>
                          <div className="col-md-6">
                            <input
                              className="form-input"
                              disabled
                              type="text"
                              value={this.state.ideaItem.OwnerOHR}
                            />
                          </div>
                        </div>
                        <div style={{ marginBottom: 15 }} />
                        <div className="row">
                          <div className="col-md-5">
                            <label
                              style={{
                                verticalAlign: "bottom",
                                marginBottom: -5,
                              }}
                            >
                              Owner Name
                            </label>{" "}
                          </div>
                          <div className="col-md-6">
                            <input
                              className="form-input"
                              disabled
                              type="text"
                              value={this.state.ideaItem.OwnerName}
                            />
                          </div>
                        </div>
                        <div style={{ marginBottom: -10 }} />
                        <p
                          className="u-align-left u-text u-text-7 u-text-custom-color-3"
                          style={{ fontSize: 11, marginBottom: 10 }}
                        >
                          (If Idea was raised for someone else, their OHR ID is
                          below)
                        </p>
                        <div className="row">
                          <div className="col-md-5">
                            <label
                              style={{
                                verticalAlign: "bottom",
                                marginBottom: -5,
                              }}
                            >
                              Request For OHR
                            </label>{" "}
                          </div>
                          <div className="col-md-6">
                            <input
                              className="form-input"
                              disabled
                              type="text"
                              defaultValue={this.state.ideaItem.CreatorOHR}
                              onChange={this.handleCreatorOHRChange}
                            />
                          </div>
                        </div>
                        <div style={{ marginBottom: 10 }} />
                        <div className="row">
                          <div className="col-md-5">
                            <label
                              style={{
                                verticalAlign: "bottom",
                                marginBottom: -5,
                              }}
                            >
                              Name
                            </label>{" "}
                          </div>
                          <div className="col-md-6">
                            <input
                              className="form-input"
                              disabled
                              type="text"
                              defaultValue={this.state.ideaItem.CreatorName}
                              onChange={this.handleCreatorNameChange}
                            />
                          </div>
                        </div>
                        <div style={{ marginBottom: 10 }} />
                        {this.state.ideaItem.LeanID !== null ? (
                          <div className="row">
                            <div className="col-md-5">
                              <label
                                style={{
                                  verticalAlign: "bottom",
                                  marginBottom: -5,
                                }}
                              >
                                Project ID
                              </label>{" "}
                            </div>
                            <div className="col-md-6">
                              <input
                                className="form-input"
                                disabled
                                type="text"
                                defaultValue={this.state.ideaItem.LeanID}
                              />
                            </div>
                          </div>
                        ) : (
                          <div className="row">
                            <div className="col-md-5">
                              <label
                                style={{
                                  verticalAlign: "bottom",
                                  marginBottom: 12,
                                }}
                              >
                                &nbsp;
                              </label>{" "}
                            </div>
                          </div>
                        )}
                        <div style={{ marginBottom: 10 }} />
                      </div>
                    </div>

                    <p
                      className="visible-md-block visible-sm-block visible-xs-block"
                      style={{ marginTop: 235 }}
                    >
                      &nbsp;
                    </p>

                    <div
                      className="u-border-1 u-border-palette-5-base u-container-style u-group u-radius-6 u-shape-round u-group-4"
                      style={{ marginTop: "-305px" }}
                    >
                      <div
                        className=""
                        style={{ display: "flex", marginTop: "30px" }}
                      >
                        <div className="u-container-style u-group u-shape-rectangle u-group-5">
                          <div className="u-container-layout u-container-layout-5">
                            <p
                              className="u-align-left u-text u-text-8"
                              style={{ marginBottom: 15 }}
                            >
                              Account Details
                            </p>
                            <div className="row">
                              <div className="col-md-5">
                                <label
                                  style={{
                                    verticalAlign: "bottom",
                                    marginBottom: -5,
                                  }}
                                >
                                  Account&nbsp;Name
                                </label>
                              </div>
                              <div className="col-md-7">
                                <input
                                  className="form-input"
                                  disabled
                                  list="accounts"
                                  name="accounts"
                                  placeholder="Choose Account"
                                  value={this.state.ideaItem.AccountManual}
                                />
                              </div>
                            </div>
                            <div style={{ marginBottom: 15 }} />
                            <div className="row">
                              <div className="col-md-5">
                                <label
                                  style={{
                                    verticalAlign: "bottom",
                                    marginBottom: -5,
                                  }}
                                >
                                  Holding&nbsp;Account
                                </label>
                              </div>
                              <div className="col-md-7">
                                <input
                                  className="form-input"
                                  disabled
                                  type="text"
                                  value={this.state.ideaItem.HoldingAccount}
                                />
                              </div>
                            </div>
                            <div style={{ marginBottom: 15 }} />
                            <div className="row">
                              <div className="col-md-5">
                                <label
                                  style={{
                                    verticalAlign: "bottom",
                                    marginBottom: -5,
                                  }}
                                >
                                  Vertical
                                </label>
                              </div>
                              <div className="col-md-7">
                                <input
                                  className="form-input"
                                  disabled
                                  list="vertical"
                                  name="vertical"
                                  placeholder="Choose Vertical"
                                  value={this.state.ideaItem.VerticalManual}
                                />
                              </div>
                            </div>
                            <div style={{ marginBottom: 15 }} />
                            <div className="row">
                              <div className="col-md-5">
                                <label
                                  style={{
                                    verticalAlign: "bottom",
                                    marginBottom: -5,
                                  }}
                                >
                                  Industry&nbsp;Vertical
                                </label>
                              </div>
                              <div className="col-md-7">
                                <input
                                  className="form-input"
                                  disabled
                                  placeholder="Choose Industry&nbsp;Vertical"
                                  value={this.state.ideaItem.SubVerticalName}
                                />
                              </div>
                            </div>
                            <div style={{ marginBottom: 15 }} />

                            {/* units and segments starts here */}
                            <div className="row">
                              <div className="col-md-5">
                                <label className="form-attribute" style={{ verticalAlign: 'bottom', marginBottom: -5 }}>Segment</label>
                              </div>
                              <div className="col-md-7">
                                <input className="form-input" disabled name="segment" value={this.state.ideaItem.Segment ? this.state.ideaItem.Segment : ""} style={{ fontWeight: 'normal !important' }} />
                              </div>
                            </div>
                            <div style={{ marginBottom: 15 }} />
                            <div className="row">
                              <div className="col-md-5">
                                <label className="form-attribute" style={{ verticalAlign: 'bottom', marginBottom: -5 }}>Unit</label>
                              </div>
                              <div className="col-md-7">
                                <input className="form-input" disabled name="unit" value={this.state.ideaItem.Unit ? this.state.ideaItem.Unit : ""} style={{ fontWeight: 'normal !important' }} />
                              </div>
                            </div>
                            <div style={{ marginBottom: 15 }} />
                            {/* units and segments ends here */}



                            <div className="row">
                              <div className="col-md-5">
                                <label
                                  style={{
                                    verticalAlign: "bottom",
                                    marginBottom: -5,
                                  }}
                                >
                                  <span style={{ color: "red" }}>* </span>
                                  Campaign&nbsp;Name
                                </label>
                              </div>
                              <div className="col-md-7">
                                <Select
                                  tabIndex={4}
                                  isSearchable={true}
                                  options={this.renderCampaignOptions()}
                                  styles={this.state.selectStyle.campaignSelectedOption}
                                  placeholder="Choose Campaign"
                                  onChange={(e) => this.handleCampaignNameChange(e)}
                                  value={this.state.campaignSelectedOption}
                                />
                              </div>

                              <div className="">
                                <div className="campaign_modal_bulb campaign_tool_tip">
                                  <img
                                    src={require("../assets/images/question_mark_2.png")}
                                    alt=""
                                    className=""
                                  />
                                  {
                                    this.state.campaignInsight
                                      ?
                                      <>
                                        <span className="my_tooltiptext">{this.state.campaignInsight}</span>
                                      </>
                                      :
                                      null
                                  }
                                </div>
                              </div>
                            </div>
                            <div style={{ marginBottom: 15 }} />
                            
                            {this.state.displayProjectTheme && this.state.campaignSelectedOption?.label === DATA_BRIDGE_CAMPAIGN && (
                                <>
                                  <div className="row">
                                    <div className="col-md-5" >
                                      <label style={{verticalAlign: "bottom",marginBottom: -5,}}>
                                        <span style={{ color: "red" }}>*&nbsp;</span>
                                        DataBridge Project Theme
                                      </label>
                                    </div>
                                    <div className="col-md-7">
                                      <Select
                                        isSearchable={true}
                                        options={this.renderDataBridgeThemeOptions()}
                                        styles={this.state.selectStyle.dataBridgeProjectTheme}
                                        placeholder="Choose Project Theme"
                                        value={this.state.databridgeThemeSelectedOptions}
                                        onChange={this.handleDataBridgeProjectThemeChange}
                                      />
                                    </div>
                                  </div>
                                  <div style={{ marginBottom: 15 }} />
                                </>
                              )}

                            
                            {(this.state.displaySubCampaign || this.state.campaignSelectedOption?.label === "Gen AI") && (
                              <>
                                <div className="row">
                                  <div className="col-md-5">
                                    <label style={{verticalAlign: "bottom",marginBottom: -5,}}>
                                      <span style={{color:"red"}}>*&nbsp;</span>
                                      {
                                        this.state.campaignSelectedOption?.label === "Gen AI"
                                        ?
                                        "Gen AI Theme"
                                        :
                                        "Sub Campaign"
                                      }
                                    </label>
                                  </div>
                                  <div className="col-md-7">
                                    <Select
                                      isSearchable={true}
                                      options={this.renderSubCampaignOptions()}
                                      styles={this.state.selectStyle.subCampaignOption}
                                      placeholder="Choose Sub Campaign"
                                      value={this.state.subCampaignOption}
                                      onChange={this.handleSubCampaignChange}
                                    />
                                  </div>
                                </div>
                                <div style={{ marginBottom: 15 }} />
                              </>
                            )}

                            



                            {
                              this.state.campaignSelectedOption?.label === AIFIRST
                                ?
                                <>
                                  <div className="row">
                                    <div className="col-md-5">
                                      <label
                                        style={{
                                          verticalAlign: "bottom",
                                          marginBottom: -5,
                                        }}
                                      >
                                        <i>AI First Sample Ideas</i>
                                      </label>
                                    </div>
                                    <div className="col-md-7">
                                      <div className="ai_first_doc_link ai_first_doc_red_highlight">
                                        <a
                                          className="ldt-list1"
                                          href={AI_DOC_LINK}
                                          target="_blank"
                                          rel="noreferrer"
                                          style={{ textAlign: "left", fontSize: 16, color: "red" }}
                                        >Document Link </a>
                                      </div>

                                    </div>
                                  </div>

                                  <div className="row d_flex_align_items_center" style={{ marginTop: "20px" }} >
                                    <div className="col-md-5">
                                      <label
                                        style={{
                                          verticalAlign: "bottom",
                                          marginBottom: -5,
                                        }}
                                      >
                                        AI Recommendation
                                      </label>
                                    </div>
                                    <div className="col-md-7">
                                      <input
                                        disabled
                                        value={this.state.isAI}
                                        placeholder="Please choose value"
                                        className="form-input disabled_input"
                                      />
                                    </div>
                                  </div>
                                  <div style={{ marginBottom: 20 }} />


                                  <div className="row d_flex_align_items_center" style={{ marginTop: "20px" }}>
                                    <div className="col-md-5">
                                      <label
                                        style={{
                                          verticalAlign: "bottom",
                                          marginBottom: 5,
                                        }}
                                      >
                                        AI First BRD
                                      </label>
                                    </div>
                                    <div className="col-md-7">
                                      <div className="ai_first_doc_link ">
                                        {/* <a
                                      className="ldt-list1"
                                      href={this.state.AIBRD}
                                      target="_blank"
                                      rel="noreferrer"
                                      style={{ textAlign: "left", fontSize: 16 }}
                                    >{this.state.AIBRD}</a> */}
                                        <textarea className="ai_first_brd_textarea" onClick={(e) => this.handleAIDocumentClick(this.state.AIBRD)} value={this.state.AIBRD} ></textarea>
                                      </div>
                                    </div>
                                  </div>

                                </>
                                :
                                null
                            }
                          </div>
                        </div>
                        <div className="u-container-layout u-container-layout-6">
                          <div className="row" style={{ marginTop: "10px" }}>
                            <div className="col-md-5">
                              <label
                                style={{
                                  verticalAlign: "bottom",
                                  marginBottom: -5,
                                }}
                              >
                                Country
                              </label>
                            </div>
                            <div className="col-md-7">
                              <input
                                className="form-input"
                                disabled
                                list="country"
                                name="country"
                                placeholder="Choose Country"
                                value={this.state.ideaItem.Country}
                              />
                            </div>
                          </div>
                          <div style={{ marginBottom: 15 }} />
                          <div className="row">
                            <div className="col-md-5">
                              <label
                                style={{
                                  verticalAlign: "bottom",
                                  marginBottom: -5,
                                }}
                              >
                                Region
                              </label>
                            </div>
                            <div className="col-md-7">
                              <input
                                className="form-input"
                                disabled
                                list="regions"
                                name="regions"
                                placeholder="Choose Region"
                                value={this.state.ideaItem.RegionManual}
                              />
                            </div>
                          </div>
                          <div style={{ marginBottom: 15 }} />
                          <div className="row">
                            <div className="col-md-5">
                              <label
                                style={{
                                  verticalAlign: "bottom",
                                  marginBottom: -5,
                                }}
                              >
                                Sub-Region
                              </label>
                            </div>
                            <div className="col-md-7">
                              <input
                                className="form-input"
                                disabled
                                list="subregions"
                                name="subregions"
                                placeholder="Choose Sub Region"
                                value={this.state.ideaItem.SubRegion}
                              />
                            </div>
                          </div>
                          <div style={{ marginBottom: 15 }} />
                          <div className="row">
                            <div className="col-md-5">
                              <label
                                style={{
                                  verticalAlign: "bottom",
                                  marginBottom: -5,
                                }}
                              >
                                Blackbelt&nbsp;Name
                              </label>
                            </div>
                            <div className="col-md-7">
                              <input
                                className="form-input"
                                disabled
                                list="blackbelt"
                                name="blackbelt"
                                placeholder="Choose Blackbelt"
                                title={
                                  "OHR ID: " +
                                  this.state.ideaItem.BlackBeltUserId
                                }
                                value={this.state.ideaItem.BlackBeltUserName}
                              />
                            </div>
                          </div>
                          <div style={{ marginBottom: 15 }} />

                          <div className="row">
                            <div className="col-md-5">
                              <label
                                className="form-attribute"
                                style={{
                                  verticalAlign: "bottom",
                                  marginBottom: -5,
                                }}
                              >
                                <label
                                  style={{
                                    color: "red",
                                    verticalAlign: "bottom",
                                  }}
                                >
                                  *
                                </label>{" "}
                                MBB
                              </label>
                            </div>
                            <div className="col-md-7">
                              <Select
                                tabIndex={10}
                                isSearchable={true}
                                value={this.state.mbbSelectedOption}
                                options={this.renderMBBOptions()}
                                styles={this.state.selectStyle.mbbUserName}
                                placeholder="Choose MBB"
                                onChange={this.handleMBBChange}
                              />
                            </div>
                          </div>
                          <div style={{ marginBottom: 15 }} />


                          {
                            this.state.campaignSelectedOption?.label === AIFIRST
                              ?
                              <>
                                <div style={{ marginBottom: 20 }} />
                                <div className="row d_flex_align_items_center">
                                  <div className="col-md-12">
                                    <label
                                      style={{
                                        verticalAlign: "bottom",
                                        marginBottom: 5,
                                      }}
                                    >
                                      AI First Reason
                                    </label>
                                  </div>
                                  <div className="col-md-12">
                                    <textarea
                                      value={this.state.AIReason}
                                      placeholder="Please provide value"
                                      className="form-input disabled_input"
                                      disabled
                                      rows={4}
                                      style={{
                                        width: "100%",
                                        border: "1px solid lightgrey",
                                        resize: "none"
                                      }}
                                    />
                                  </div>
                                </div>
                                <div style={{ marginBottom: 20 }} />
                              </>
                              :
                              null
                          }

                          <div style={{ marginBottom: 15 }} />
                        </div>
                      </div>
                    </div>

                    

                    
                    <div
                      id="idea1"
                      className="u-border-1 u-border-palette-5-base u-container-style u-expanded-width u-group u-radius-6 u-shape-round u-group-7"
                      style={{ paddingTop: 15, borderTop:"1px solid lightgrey" }}
                    >
                      <div className="u-container-layout u-container-layout-7">
                        <div className="u-container-style u-group u-shape-rectangle u-group-8">
                          <div className="u-container-layout u-container-layout-8">
                            <p
                              id="idea1title"
                              className="u-align-left u-text u-text-2"
                              style={{ marginBottom: 10 }}
                            >
                              Idea details
                            </p>
                            <div className="row">
                              <div className="col-md-4">
                                <label
                                  style={{
                                    verticalAlign: "bottom",
                                    marginBottom: -5,
                                  }}
                                >
                                  <span style={{ color: "red" }}>*</span>{" "}
                                  Service&nbsp;Line
                                </label>
                              </div>
                              <div className="col-md-8">
                                <Select
                                  isSearchable={true}
                                  options={this.renderServiceLineOptions(
                                    this.state.serviceLineSelectedOption
                                  )}
                                  styles={
                                    this.state.selectStyle.serviceLineText
                                  }
                                  placeholder="Choose Service Line"
                                  value={this.state.serviceLineSelectedOption}
                                  onChange={(e) =>
                                    this.handleServiceLineChange(e)
                                  }
                                />
                              </div>
                            </div>
                            <div style={{ marginBottom: 15 }} />
                            <div className="row">
                              <div className="col-md-4">
                                <label
                                  style={{
                                    verticalAlign: "bottom",
                                    marginBottom: -5,
                                  }}
                                >
                                  <span style={{ color: "red" }}>*</span>{" "}
                                  Sub-Service&nbsp;Line
                                </label>
                              </div>
                              <div className="col-md-8">
                                <Select
                                  isSearchable={true}
                                  options={this.renderSubServiceLineOptions()}
                                  styles={this.state.selectStyle.subServiceLine}
                                  placeholder="Choose Sub-Service Line"
                                  value={
                                    this.state.subServiceLineSelectedOption
                                  }
                                  onChange={(e) =>
                                    this.handleSubServiceLineChange(e)
                                  }
                                />
                              </div>
                            </div>
                            <div style={{ marginBottom: 15 }} />
                            <div className="row">
                              <div className="col-md-7">
                                <p className="u-align-left u-text u-text-custom-color-4 u-text-8">
                                  <span className="u-text-black form-attribute">
                                    <span style={{ color: "red" }}>*</span>
                                    &nbsp;What is the Problem ?&nbsp;
                                    <span
                                      style={{
                                        fontWeight: "normal",
                                        fontSize: 12,
                                        fontStyle: "italic",
                                        color: "grey",
                                      }}
                                    >
                                      (max. 2000 chars)
                                    </span>
                                  </span>
                                </p>
                              </div>
                              <div
                                className="col-md-5"
                                style={{
                                  display: "flex",
                                  justifyContent: "flex-end",
                                  alignItems: "center",
                                }}
                              >
                                <img
                                  onClick={(e) =>
                                    this.toggleTranscriptFunction(11)
                                  }
                                  src={require("../assets/images/voice.png")}
                                  className="w100"
                                  alt=""
                                  style={{ width: "24px", cursor: "pointer" }}
                                />
                              </div>
                            </div>

                            <div className="row">
                              <div className="col-md-12">
                                <textarea
                                  className="textarea-css form-attribute"
                                  rows={6}
                                  cols={80}
                                  style={{
                                    maxWidth: "100%",
                                    border: "1px solid lightgrey",
                                    ...this.state.selectStyle.Problem,
                                  }}
                                  value={this.state.ideaItem.Problem}
                                  onChange={(event) =>
                                    this.handleProblemChange(event.target.value)
                                  }
                                />
                              </div>
                            </div>
                          </div>
                          {this.state.speechModal ? (
                            <UpdatedSpeech
                              modalOpen={this.state.speechModal}
                              onReviewTranscriptProblem={
                                this.handleTranscriptProblemChange
                              }
                              onReviewTranscriptSolution={
                                this.handleTranscriptSolutionChange
                              }
                              onTranscriptComment={
                                this.handleTranscriptCommentChange
                              }
                              modalId={this.state.modalIndex}
                              closeModalFunction={this.closeModalFunction}
                              previousText={this.state.previousTextForSpeech}
                              onRequestCancellation={
                                this.handleTranscriptCommentChange
                              }
                            />
                          ) : null}
                        </div>
                        <div className="u-container-style u-group u-shape-rectangle u-group-9">
                          <div
                            className="u-container-layout u-container-layout-9"
                            style={{ marginTop: -5 }}
                          >
                            <div className="row">
                              <div className="col-md-4">
                                <label
                                  style={{
                                    verticalAlign: "bottom",
                                    marginBottom: -5,
                                  }}
                                >
                                  Idea Name
                                </label>
                              </div>
                              <div
                                className="col-md-8"
                                style={{ alignItems: "flex-start" }}
                              >
                                <input
                                  className="form-input"
                                  disabled
                                  type="text"
                                  value={this.state.ideaItem.IdeaName}
                                  placeholder="Eg: Cash flow improvement through process restructuring"
                                />
                              </div>
                            </div>
                            <div style={{ marginBottom: 70 }} />
                            <div className="row">
                              <div className="col-md-7">
                                <p
                                  className="u-align-left u-text u-text-custom-color-4 u-text-8"
                                  style={{ width: "287px" }}
                                >
                                  <span className="u-text-black form-attribute">
                                    <span style={{ color: "red" }}>*</span>
                                    &nbsp;How to resolve the problem&nbsp;
                                    <span
                                      style={{
                                        fontWeight: "normal",
                                        fontSize: 12,
                                        fontStyle: "italic",
                                        color: "grey",
                                      }}
                                    >
                                      (max. 2000 chars)
                                    </span>
                                  </span>
                                </p>
                              </div>
                              <div
                                className="col-md-5"
                                style={{
                                  display: "flex",
                                  justifyContent: "flex-end",
                                  alignItems: "center",
                                }}
                              >
                                <img
                                  onClick={(e) =>
                                    this.toggleTranscriptFunction(12)
                                  }
                                  src={require("../assets/images/voice.png")}
                                  className="w100"
                                  alt=""
                                  style={{ width: "24px", cursor: "pointer" }}
                                />
                              </div>
                            </div>

                            <div className="row">
                              <div className="col-md-12">
                                <textarea
                                  className="textarea-css form-attribute"
                                  rows={6}
                                  cols={80}
                                  style={{
                                    maxWidth: "100%",
                                    border: "1px solid lightgrey",
                                    ...this.state.selectStyle.Solution,
                                  }}
                                  value={this.state.ideaItem.Solution}
                                  onChange={(event) =>
                                    this.handleSolutionChange(
                                      event.target.value
                                    )
                                  }
                                />
                              </div>
                            </div>
                          </div>
                        </div>
                        <div className="row" style={{ marginTop: 20 }}>
                          <div className="col-md-5">
                            <label
                              style={{
                                verticalAlign: "bottom",
                                marginBottom: -5,
                              }}
                            >
                              Are you trying to replicate an existing Idea?
                            </label>
                            {/* <span style={{ color: 'red' }}>*</span> */}
                          </div>
                          <div className="col-md-4">
                            <label className="switch">
                              <input
                                type="checkbox"
                                checked={
                                  this.state.ideaItem.NewOrReplicatedIdea ===
                                    null
                                    ? false
                                    : this.state.ideaItem.NewOrReplicatedIdea
                                }
                                onChange={() => this.showHideDiv()}
                              />
                              <span className="slider round" />
                            </label>
                          </div>
                        </div>

                        {this.state.ideaItem.NewOrReplicatedIdea && (
                          <>
                            <div
                              className="col-md-8"
                              style={{ marginBottom: 15, width: "100%" }}
                            />
                            <div className="row">
                              <div className="col-md-5">
                                <label
                                  style={{
                                    verticalAlign: "bottom",
                                    marginBottom: -5,
                                  }}
                                >
                                  <label style={{ color: "red" }}>*</label>{" "}
                                  Provide the ID of the executed Idea which you
                                  want to replicate?
                                </label>
                              </div>
                              <div className="col-md-2">
                                <input
                                  className="textarea-css form-attribute"
                                  type="text"
                                  value={
                                    this.state.ideaItem.ReplicationProjectId
                                  }
                                  onChange={(event) => {
                                    this.handleReplicationIdChange(
                                      event.target.value
                                    );
                                  }}
                                  onKeyPress={(event) => {
                                    if (event.key === "Enter") {
                                      this.validateReplicationId(
                                        event.target.value
                                      );
                                    }
                                  }}
                                  style={{
                                    border: "1px solid lightgrey",
                                    ...this.state.selectStyle
                                      .ReplicationProjectId,
                                  }}
                                />
                              </div>
                              <div className="col-md-1">
                                <i
                                  className="fa fa-check-square-o"
                                  style={{
                                    marginTop: 5,
                                    color: "#FF555F",
                                    fontSize: 24,
                                  }}
                                  onClick={(event) => {
                                    this.validateReplicationId(
                                      this.state.ideaItem.ReplicationProjectId
                                    );
                                  }}
                                />
                              </div>
                            </div>
                          </>
                        )}

                        <div
                          className="col-md-8"
                          style={{ marginBottom: 15, marginTop: 5 }}
                        />
                      </div>
                    </div>

                      {this.state.ideaItem.WorkflowStatus && (this.state.ideaItem.WorkflowStatus === "Approve" || this.state.ideaItem.WorkflowStatus === "Approved") && (
                        <>
                          <div style={{ borderBottom: "1px solid lightgrey", marginBottom: 15,}} />
                          <div id="Potential Impact" className="u-border-1 u-border-palette-5-base u-container-style u-expanded-width u-group u-radius-6 u-shape-round u-group-7">
                            <div className="u-container-layout u-container-layout-7">
                              <div className="u-container-style u-group u-shape-rectangle u-group-8">
                                <div className="u-container-layout u-container-layout-8">
                                  <p
                                    id="Potential Impact"
                                    className="u-align-left u-text u-text-2"
                                    style={{ marginBottom: 10 }}
                                  >
                                    Additional details
                                  </p>
                                  <div className="row">
                                    <div className="col-md-6">
                                      <span className="form-attribute">
                                        LDT Lead Name
                                      </span>
                                    </div>
                                    <div className="col-md-6">
                                      <input
                                        className="form-input"
                                        disabled
                                        list="ldtName"
                                        name="ldtName"
                                        placeholder="Choose LDT Lead"
                                        value={this.state.ideaItem.LDTLeadName}
                                      />
                                    </div>
                                  </div>
                                  <div style={{ marginBottom: 5 }} />
                                  <div
                                    style={{ marginTop: 10, marginBottom: 14 }}
                                  />
                                  {this.state.ideaItem.NewOrReplicatedIdea && (
                                    <div className="row">
                                      <div className="col-md-10">
                                        <label
                                          style={{
                                            verticalAlign: "bottom",
                                            marginBottom: -5,
                                          }}
                                        >
                                          Have you verified the replication id
                                          and confirm this to be replication
                                          project?
                                        </label>
                                      </div>
                                      <div className="col-md-2">
                                        <label className="switch">
                                          <input
                                            disabled
                                            type="checkbox"
                                            checked={
                                              this.state.ideaItem
                                                .IsReplicationVerified
                                            }
                                          />
                                          <span className="slider round" />
                                        </label>
                                      </div>
                                      <div style={{ marginBottom: 45 }} />
                                    </div>
                                  )}
                                  {!this.state.ideaItem.NewOrReplicatedIdea && (
                                    <div className="row">
                                      <div className="col-md-10">
                                        <label
                                          style={{
                                            verticalAlign: "bottom",
                                            marginBottom: 17,
                                          }}
                                        >
                                          &nbsp;
                                        </label>
                                      </div>
                                    </div>
                                  )}
                                </div>
                              </div>

                              <p className="visible-md-block visible-sm-block visible-xs-block" style={{ marginTop: 45 }}>&nbsp;</p>

                              <div className="u-container-style u-group u-shape-rectangle u-group-9">
                                <div className="u-container-layout u-container-layout-9" style={{ marginTop: "177px" }}>
                                  <p className="visible-md-block visible-sm-block visible-xs-block" style={{ marginTop: "-260px" }}>&nbsp;</p>
                                  <div className="row">
                                    <div className="col-md-5">
                                      <span className="form-attribute">
                                        Certification Level
                                      </span>{" "}
                                    </div>
                                    <div className="col-md-7">
                                      <input
                                        className="form-input"
                                        disabled
                                        name="certlevel"
                                        value={this.state.ideaItem.CertificationLevelName}
                                      />
                                    </div>
                                  </div>
                                  <div style={{ marginBottom: 15 }} />
                                  <div className="row">
                                    <div className="col-md-5">
                                      <span className="form-attribute">
                                        Transformation Lever
                                      </span>
                                    </div>
                                    <div className="col-md-7">
                                      <input
                                        className="form-input"
                                        disabled
                                        name="translever"
                                        value={this.state.ideaItem.TransformationLeverName}
                                      />
                                    </div>
                                  </div>
                                  <div style={{ marginBottom: 15 }} />
                                  {this.state.ideaItem.TransformationLeverName === "Digital" && (
                                    <>
                                      <div className="row">
                                        <div className="col-md-5">
                                          <span className="form-attribute">
                                            Digital Project Type
                                          </span>
                                        </div>
                                        <div className="col-md-7">
                                          <input
                                            className="form-input"
                                            disabled
                                            name="translever"
                                            value={this.state.ideaItem.DigitalProjectType}
                                          />
                                        </div>
                                      </div>
                                      <div style={{ marginBottom: 15 }} />
                                    </>
                                  )}


                                  {
                                    this.state.ideaItem.CertificationWorkTypeName && (
                                      <div className="row" style={{ marginBottom: 15 }}>
                                        <div className="col-md-5">
                                          <span className="form-attribute">
                                            Work Type
                                          </span>{" "}
                                        </div>
                                        <div className="col-md-7">
                                          <input
                                            className="form-input"
                                            disabled
                                            name="worktype"
                                            value={this.state.ideaItem.CertificationWorkTypeName ? this.state.ideaItem.CertificationWorkTypeName : ""}
                                          />
                                        </div>
                                      </div>

                                    )
                                  }

                                  {this.state.ideaItem.AIClassification
                                    ?
                                    <>
                                      <div className="row">
                                        <div className="col-md-5">
                                          <span className="form-attribute">
                                            AI Classification
                                          </span>
                                        </div>
                                        <div className="col-md-7">
                                          <input
                                            placeholder="AI Classification"
                                            title={this.state.ideaItem.AIClassification}
                                            className="form-input"
                                            disabled
                                            name="ai classification"
                                            value={this.state.ideaItem.AIClassification}
                                          />
                                        </div>
                                      </div>
                                      <div style={{ marginBottom: 15 }} />
                                    </>
                                    :
                                    null
                                  }
                                  <div className="row" style={{ marginBottom: 15 }}>
                                    <div className="col-md-5">
                                      <span className="form-attribute">
                                        Tools/Methodology Used
                                      </span>
                                    </div>
                                    <div className="col-md-7">
                                      <input
                                        className="form-input"
                                        disabled
                                        name="methodology"
                                        value={this.state.ideaItem.MethodologyName}
                                      />
                                    </div>
                                  </div>

                                  {
                                    this.state.ideaItem.OtherTools && (
                                      <div className="row">
                                        <div className="col-md-5">
                                          <span className="form-attribute">
                                            Other Tools
                                          </span>
                                        </div>
                                        <div className="col-md-7">
                                          <input
                                            className="form-input"
                                            disabled
                                            name="methodology"
                                            value={this.state.ideaItem.OtherTools}
                                          />
                                        </div>
                                      </div>
                                    )
                                  }
                                  <div style={{ marginBottom: 25 }} />
                                </div>
                              </div>
                            </div>
                          </div>
                        </>
                      )}
                    
                    
                    {this.state.reviewComments && (
                      <>
                        <div
                          style={{
                            borderBottom: "1px solid lightgrey",
                            marginBottom: 15,
                          }}
                        />
                        <div
                          id="Approval Status"
                          className="u-border-1 u-border-palette-5-base u-container-style u-expanded-width u-group u-radius-6 u-shape-round u-group-7"
                        >
                          <div className="u-container-layout u-container-layout-7">
                            <p
                              className="u-align-left u-text u-text-2"
                              style={{ marginBottom: 10 }}
                            >
                              Idea Approval details
                            </p>
                            <div className="row">
                              <div className="col-md-2">
                                <span className="form-attribute">
                                  Approval Status
                                </span>{" "}
                              </div>
                              <div className="col-md-2">
                                <input 
                                  title={this.state.ideaItem.ApprovalStatus}
                                  className="form-input"
                                  disabled
                                  value={this.state.ideaItem.ApprovalStatus}
                                />
                              </div>
                            </div>
                            <div className="row" style={{ marginTop: 15 }}>
                              <div className="col-md-5">
                                <label
                                  style={{
                                    verticalAlign: "bottom",
                                    marginBottom: -5,
                                  }}
                                >
                                  Comments
                                </label>
                              </div>
                              <div
                                className="col-md-2"
                                style={{ marginLeft: 20 }}
                              >
                                <button
                                  className="u-active-custom-color-6 u-border-2 u-border-active-black u-border-hover-black u-border-white u-btn u-btn-round u-button-style u-custom-color-3 u-hover-custom-color-6 u-radius-6 u-btn-3"
                                  onClick={(e) =>
                                    this.setState({
                                      commentLog: !this.state.commentLog,
                                    })
                                  }
                                >
                                  Comment Log
                                </button>
                              </div>
                            </div>
                            <div className="row" style={{ marginTop: 5 }}>
                              <div className="col-md-12">
                                <textarea
                                  className="form-input"
                                  disabled
                                  rows={3}
                                  cols={88}
                                  style={{
                                    maxWidth: "100%",
                                    border: "1px solid lightgrey",
                                  }}
                                  name="Comments"
                                  value={this.state.ideaItem.Comment}
                                />
                              </div>
                            </div>
                            <div className="text-left mt-4">
                              {this.state.commentLog &&
                                this.state.reviewComments ? (
                                <>
                                  <div className="custom_modal">
                                    <div className="modal_body">
                                      <div className="row">
                                        <div className="col-md-8">
                                          <h3 className="modal_title">
                                            Idea Approval Comment Log
                                          </h3>
                                        </div>
                                        <div className="col-md-4">
                                          <button
                                            type="button"
                                            className="close text-right"
                                            onClick={(e) =>
                                              this.setState({
                                                commentLog: false,
                                              })
                                            }
                                          >
                                            &times;
                                          </button>
                                        </div>
                                      </div>
                                      <div className="row">
                                        <div
                                          className="col-md-2 text-center"
                                          style={{
                                            border: "1px solid lightgrey",
                                            backgroundColor: "gainsboro",
                                          }}
                                        >
                                          <label
                                            style={{
                                              fontWeight: 100,
                                              verticalAlign: "bottom",
                                            }}
                                          >
                                            Date & Time
                                          </label>
                                        </div>
                                        <div
                                          className="col-md-2 text-center"
                                          style={{
                                            border: "1px solid lightgrey",
                                            backgroundColor: "gainsboro",
                                          }}
                                        >
                                          <label
                                            style={{
                                              fontWeight: 100,
                                              verticalAlign: "bottom",
                                            }}
                                          >
                                            OHR
                                          </label>
                                        </div>
                                        <div
                                          className="col-md-2 text-center"
                                          style={{
                                            border: "1px solid lightgrey",
                                            backgroundColor: "gainsboro",
                                          }}
                                        >
                                          <label
                                            style={{
                                              fontWeight: 100,
                                              verticalAlign: "bottom",
                                            }}
                                          >
                                            Name
                                          </label>
                                        </div>
                                        <div
                                          className="col-md-1 text-center"
                                          style={{
                                            border: "1px solid lightgrey",
                                            backgroundColor: "gainsboro",
                                          }}
                                        >
                                          <label
                                            style={{
                                              fontWeight: 100,
                                              verticalAlign: "bottom",
                                            }}
                                          >
                                            Role
                                          </label>
                                        </div>
                                        <div
                                          className="col-md-2 text-center"
                                          style={{
                                            border: "1px solid lightgrey",
                                            backgroundColor: "gainsboro",
                                          }}
                                        >
                                          <label
                                            style={{
                                              fontWeight: 100,
                                              verticalAlign: "bottom",
                                            }}
                                          >
                                            Action
                                          </label>
                                        </div>
                                        <div
                                          className="col-md-3 text-center"
                                          style={{
                                            border: "1px solid lightgrey",
                                            backgroundColor: "gainsboro",
                                          }}
                                        >
                                          <label
                                            style={{
                                              fontWeight: 100,
                                              verticalAlign: "bottom",
                                            }}
                                          >
                                            Comment
                                          </label>
                                        </div>
                                      </div>
                                      {this.state.reviewComments.map(
                                        (item, index) => {
                                          return (
                                            <div className="row" key={index}>
                                              <div
                                                className="col-md-2 text-center"
                                                style={{
                                                  border: "1px solid lightgrey",
                                                }}
                                              >
                                                <label
                                                  style={{
                                                    lineheight: 2,
                                                    verticalAlign: "bottom",
                                                  }}
                                                >
                                                  {this.formatDateStringWithTime(
                                                    new Date(item.CreatedDate)
                                                  )}
                                                </label>
                                              </div>
                                              <div
                                                className="col-md-2 text-center"
                                                style={{
                                                  border: "1px solid lightgrey",
                                                }}
                                              >
                                                <label
                                                  style={{
                                                    lineheight: 2,
                                                    verticalAlign: "bottom",
                                                  }}
                                                >
                                                  {item.UpdaterOHR}
                                                </label>
                                              </div>
                                              <div
                                                className="col-md-2 text-center"
                                                style={{
                                                  border: "1px solid lightgrey",
                                                }}
                                              >
                                                <label
                                                  style={{
                                                    lineheight: 2,
                                                    verticalAlign: "bottom",
                                                  }}
                                                >
                                                  {item.UpdaterName}
                                                </label>
                                              </div>
                                              <div
                                                className="col-md-1 text-center role_over_flow_class"
                                                style={{
                                                  border: "1px solid lightgrey",
                                                }}
                                              >
                                                <label
                                                  style={{
                                                    lineheight: 2,
                                                    verticalAlign: "bottom",
                                                  }}
                                                >
                                                  {item.UpdaterRole
                                                    ? item.UpdaterRole
                                                    : item.Action ===
                                                      "Idea Updated by Admin" ||
                                                      item.Action ===
                                                      "Idea Reinitiated by Admin"
                                                      ? "Admin"
                                                      : item.Action ===
                                                        "Delegate Action"
                                                        ? "BB"
                                                        : item.UpdaterOHR ===
                                                          this.state.ideaItem
                                                            .BlackBeltUserId
                                                          ? "BB"
                                                          : item.UpdaterOHR ===
                                                            this.state.ideaItem.MBBOHR
                                                            ? "MBB"
                                                            : item.UpdaterOHR ===
                                                              this.state.ideaItem
                                                                .OwnerOHR
                                                              ? "Idea Owner"
                                                              : item.UpdaterRole}
                                                </label>
                                              </div>
                                              <div
                                                className="col-md-2 text-center"
                                                style={{
                                                  border: "1px solid lightgrey",
                                                }}
                                              >
                                                <label
                                                  style={{
                                                    lineheight: 2,
                                                    verticalAlign: "bottom",
                                                  }}
                                                >
                                                  {item.UpdaterAction
                                                    ? item.UpdaterAction
                                                    : item.Action ===
                                                      "Idea Reinitiated by Admin"
                                                      ? "Idea Reinitiated"
                                                      : item.Action ===
                                                        "Idea Updated by Admin"
                                                        ? item.WorkflowStatus !==
                                                          "Pending"
                                                          ? item.WorkflowStatus
                                                          : "Idea Updated"
                                                        : item.Action ===
                                                          "Delegate Action"
                                                          ? "Delegated"
                                                          : item.WorkflowStatus ===
                                                            "Pending"
                                                            ? "Discard Cancellation"
                                                            : item.WorkflowStatus}
                                                </label>
                                              </div>
                                              <div
                                                className="col-md-3 text-center"
                                                style={{
                                                  border: "1px solid lightgrey",
                                                }}
                                              >
                                                <label
                                                  style={{
                                                    lineheight: 2,
                                                    verticalAlign: "bottom",
                                                  }}
                                                >
                                                  {item.Comment
                                                    ? item.Comment
                                                    : "-"}
                                                </label>
                                              </div>
                                            </div>
                                          );
                                        }
                                      )}
                                    </div>
                                  </div>
                                </>
                              ) : null}
                            </div>
                          </div>
                        </div>
                      </>
                    )}
                    <div
                      style={{
                        borderBottom: "1px solid lightgrey",
                        marginBottom: 15,
                      }}
                    />

                    {this.state.ideaItem.ApprovalStatus ===
                      AWAITING_MENTOR_APPROVAL_FOR_CANCELLATION ||
                      this.state.ideaItem.WorkflowStatus ===
                      AWAITING_MENTOR_APPROVAL_FOR_CANCELLATION ? (
                      <>
                        {this.state.ideaItem.ApprovalStatus ===
                          AWAITING_MENTOR_APPROVAL_FOR_CANCELLATION && (
                            <div
                              id="Approval Status"
                              className="u-border-1 u-border-palette-5-base u-container-style u-expanded-width u-group u-radius-6 u-shape-round u-group-7"
                            >
                              <div className="u-container-layout u-container-layout-7">
                                <p
                                  className="u-align-left u-text u-text-2"
                                  style={{ marginBottom: 10 }}
                                >
                                  Project Approval details
                                </p>
                                <div className="row">
                                  <div className="col-md-2">
                                    <span className="form-attribute">
                                      Approval Status
                                    </span>{" "}
                                  </div>
                                  <div className="col-md-2">
                                    <input
                                      title={this.state.ideaItem.ApprovalStatus}
                                      className="form-input"
                                      disabled
                                      name="finalapprovalstatus"
                                      value={this.state.ideaItem.ApprovalStatus}
                                    />
                                  </div>
                                </div>
                                <div className="row" style={{ marginTop: 15 }}>
                                  <div className="col-md-5">
                                    <label
                                      style={{
                                        verticalAlign: "bottom",
                                        marginBottom: -5,
                                      }}
                                    >
                                      Approval Comments
                                    </label>
                                  </div>
                                  <div
                                    className="col-md-2"
                                    style={{ marginLeft: 20 }}
                                  >
                                    <button
                                      className="u-active-custom-color-6 u-border-2 u-border-active-black u-border-hover-black u-border-white u-btn u-btn-round u-button-style u-custom-color-3 u-hover-custom-color-6 u-radius-6 u-btn-3"
                                      onClick={(e) =>
                                        this.setState({
                                          finalCommentLog:
                                            !this.state.finalCommentLog,
                                        })
                                      }
                                    >
                                      Comment Log
                                    </button>
                                  </div>
                                </div>
                                <div className="row" style={{ marginTop: 5 }}>
                                  <div className="col-md-12">
                                    <textarea
                                      className="form-input"
                                      disabled
                                      rows={3}
                                      cols={88}
                                      style={{
                                        maxWidth: "100%",
                                        border: "1px solid lightgrey",
                                      }}
                                      name="Comments"
                                      value={this.state.ideaItem.FinalComments}
                                    />
                                  </div>
                                </div>
                                <div className="text-left mt-4">
                                  {this.state.finalCommentLog &&
                                    this.state.finalReviewComments ? (
                                    <>
                                      <div className="custom_modal">
                                        <div className="modal_body">
                                          <div className="row">
                                            <div className="col-md-8">
                                              <h3 className="modal_title">
                                                Lean Approval Comment Log
                                              </h3>
                                            </div>
                                            <div className="col-md-4">
                                              <button
                                                type="button"
                                                className="close text-right"
                                                onClick={(e) =>
                                                  this.setState({
                                                    finalCommentLog: false,
                                                  })
                                                }
                                              >
                                                &times;
                                              </button>
                                            </div>
                                          </div>
                                          <div className="row">
                                            <div
                                              className="col-md-2 text-center"
                                              style={{
                                                border: "1px solid lightgrey",
                                                backgroundColor: "gainsboro",
                                              }}
                                            >
                                              <label
                                                style={{
                                                  fontWeight: 100,
                                                  verticalAlign: "bottom",
                                                }}
                                              >
                                                Date & Time
                                              </label>
                                            </div>
                                            <div
                                              className="col-md-2 text-center"
                                              style={{
                                                border: "1px solid lightgrey",
                                                backgroundColor: "gainsboro",
                                              }}
                                            >
                                              <label
                                                style={{
                                                  fontWeight: 100,
                                                  verticalAlign: "bottom",
                                                }}
                                              >
                                                OHR
                                              </label>
                                            </div>
                                            <div
                                              className="col-md-2 text-center"
                                              style={{
                                                border: "1px solid lightgrey",
                                                backgroundColor: "gainsboro",
                                              }}
                                            >
                                              <label
                                                style={{
                                                  fontWeight: 100,
                                                  verticalAlign: "bottom",
                                                }}
                                              >
                                                Name
                                              </label>
                                            </div>
                                            <div
                                              className="col-md-1 text-center"
                                              style={{
                                                border: "1px solid lightgrey",
                                                backgroundColor: "gainsboro",
                                              }}
                                            >
                                              <label
                                                style={{
                                                  fontWeight: 100,
                                                  verticalAlign: "bottom",
                                                }}
                                              >
                                                Role
                                              </label>
                                            </div>
                                            <div
                                              className="col-md-2 text-center"
                                              style={{
                                                border: "1px solid lightgrey",
                                                backgroundColor: "gainsboro",
                                              }}
                                            >
                                              <label
                                                style={{
                                                  fontWeight: 100,
                                                  verticalAlign: "bottom",
                                                }}
                                              >
                                                Action
                                              </label>
                                            </div>
                                            <div
                                              className="col-md-3 text-center"
                                              style={{
                                                border: "1px solid lightgrey",
                                                backgroundColor: "gainsboro",
                                              }}
                                            >
                                              <label
                                                style={{
                                                  fontWeight: 100,
                                                  verticalAlign: "bottom",
                                                }}
                                              >
                                                Comment
                                              </label>
                                            </div>
                                          </div>
                                          {this.state.finalReviewComments.map(
                                            (item, index) => {
                                              return (
                                                <div className="row" key={index}>
                                                  <div
                                                    className="col-md-2 text-center"
                                                    style={{
                                                      border:
                                                        "1px solid lightgrey",
                                                    }}
                                                  >
                                                    <label
                                                      style={{
                                                        lineheight: 2,
                                                        verticalAlign: "bottom",
                                                      }}
                                                    >
                                                      {this.formatDateStringWithTime(
                                                        new Date(item.CreatedDate)
                                                      )}
                                                    </label>
                                                  </div>
                                                  <div
                                                    className="col-md-2 text-center"
                                                    style={{
                                                      border:
                                                        "1px solid lightgrey",
                                                    }}
                                                  >
                                                    <label
                                                      style={{
                                                        lineheight: 2,
                                                        verticalAlign: "bottom",
                                                      }}
                                                    >
                                                      {item.UpdaterOHR}
                                                    </label>
                                                  </div>
                                                  <div
                                                    className="col-md-2 text-center"
                                                    style={{
                                                      border:
                                                        "1px solid lightgrey",
                                                    }}
                                                  >
                                                    <label
                                                      style={{
                                                        lineheight: 2,
                                                        verticalAlign: "bottom",
                                                      }}
                                                    >
                                                      {item.UpdaterName}
                                                    </label>
                                                  </div>
                                                  <div
                                                    className="col-md-1 text-center"
                                                    style={{
                                                      border:
                                                        "1px solid lightgrey",
                                                    }}
                                                  >
                                                    <label
                                                      style={{
                                                        lineheight: 2,
                                                        verticalAlign: "bottom",
                                                      }}
                                                    >
                                                      {item.UpdaterRole
                                                        ? item.UpdaterRole
                                                        : item.Action ===
                                                          "Idea Updated by Admin" ||
                                                          item.Action ===
                                                          "Idea Reinitiated by Admin"
                                                          ? "Admin"
                                                          : item.Action ===
                                                            "Idea was reviewed by MBB"
                                                            ? "MBB"
                                                            : item.Action ===
                                                              "Idea was reviewed by LDT"
                                                              ? "LDT"
                                                              : item.UpdaterOHR ===
                                                                this.state.ideaItem
                                                                  .OwnerOHR
                                                                ? "Owner"
                                                                : "BB"}
                                                    </label>
                                                  </div>
                                                  <div
                                                    className="col-md-2 text-center"
                                                    style={{
                                                      border:
                                                        "1px solid lightgrey",
                                                    }}
                                                  >
                                                    <label
                                                      style={{
                                                        lineheight: 2,
                                                        verticalAlign: "bottom",
                                                      }}
                                                    >
                                                      {item.UpdaterAction
                                                        ? item.UpdaterAction
                                                        : item.Action ===
                                                          "Idea Reinitiated by Admin"
                                                          ? "Idea Reinitiated"
                                                          : item.Action ===
                                                            "Idea Updated by Admin"
                                                            ? item.ApprovalStatus
                                                            : item.WorkflowStatus ===
                                                              COMPLETE_STATUS ||
                                                              item.WorkflowStatus ===
                                                              "Approve" ||
                                                              item.WorkflowStatus ===
                                                              "Approved"
                                                              ? "Approved"
                                                              : item.WorkflowStatus ===
                                                                "Rejected" ||
                                                                item.WorkflowStatus ===
                                                                "Reject"
                                                                ? "Rejected"
                                                                : item.WorkflowStatus ===
                                                                  AWAITING_MENTOR_APPROVAL_FOR_CANCELLATION
                                                                  ? AWAITING_MENTOR_APPROVAL_FOR_CANCELLATION
                                                                  : item.WorkflowStatus ===
                                                                    "Pending Documents"
                                                                    ? "Discard Cancellation"
                                                                    : item.WorkflowStatus ===
                                                                      CANCEL
                                                                      ? CANCEL
                                                                      : "Sent Back"}
                                                    </label>
                                                  </div>
                                                  <div
                                                    className="col-md-3 text-center"
                                                    style={{
                                                      border:
                                                        "1px solid lightgrey",
                                                    }}
                                                  >
                                                    <label
                                                      style={{
                                                        lineheight: 2,
                                                        verticalAlign: "bottom",
                                                      }}
                                                    >
                                                      {item.Comment
                                                        ? item.Comment
                                                        : "-"}
                                                    </label>
                                                  </div>
                                                </div>
                                              );
                                            }
                                          )}
                                        </div>
                                      </div>
                                    </>
                                  ) : null}
                                </div>
                              </div>
                            </div>
                          )}
                        <div
                          id="Approval Status"
                          className="u-border-1 u-border-palette-5-base u-container-style u-expanded-width u-group u-radius-6 u-shape-round u-group-7"
                        >
                          <div className="u-container-layout u-container-layout-7">
                            <p
                              className="u-align-left u-text u-text-2"
                              style={{ marginBottom: 10 }}
                            >
                              {" "}
                              Request Cancellation details
                            </p>
                            <div className="row">
                              <div className="col-md-2">
                                <label
                                  style={{
                                    verticalAlign: "bottom",
                                    marginBottom: -5,
                                  }}
                                >
                                  <span style={{ color: "red" }}>*</span>{" "}
                                  Cancellation Status
                                </label>{" "}
                              </div>
                              <div className="col-md-2">
                                <Select
                                  isSearchable={false}
                                  options={this.renderCancelRequestOption()}
                                  styles={
                                    this.state.selectStyle
                                      .workFlowStatusSelectedOption
                                  }
                                  placeholder="Choose Status"
                                  onChange={this.handleCancelRequestChange}
                                />
                              </div>
                            </div>
                            <div
                              className="col-md-9"
                              style={{ marginBottom: 5, width: "100%" }}
                            />

                            <div className="row">
                              <div className="col-md-6">
                                <p className="u-align-left u-text u-text-custom-color-4 u-text-25">
                                  <span className="u-text-black form-attribute">
                                    <span style={{ color: "red" }}>*</span>
                                    &nbsp;Comments&nbsp;
                                    <span
                                      style={{
                                        fontWeight: "normal",
                                        fontSize: 12,
                                        fontStyle: "italic",
                                        color: "grey",
                                      }}
                                    >
                                      {" "}
                                      (max. 500 chars)
                                    </span>
                                  </span>
                                </p>
                              </div>
                              <div
                                className="col-md-2"
                                style={{
                                  display: "flex",
                                  justifyContent: "flex-start",
                                  alignItems: "center",
                                }}
                              >
                                <img
                                  onClick={(e) =>
                                    this.toggleTranscriptFunction(10)
                                  }
                                  src={require("../assets/images/voice.png")}
                                  className="w100"
                                  alt=""
                                  style={{ width: "24px", cursor: "pointer" }}
                                />
                              </div>
                            </div>

                            <div className="row">
                              <div className="col-md-12">
                                {this.state.CommentEmpty ? (
                                  <textarea
                                    className="textarea-css form-attribute"
                                    style={{
                                      maxWidth: "100%",
                                      border: "1px solid lightgrey",
                                      ...this.state.selectStyle.comment,
                                    }}
                                    placeholder="Please provide your comments regarding the cancellation request."
                                    onChange={this.handleCommentChange}
                                    rows={3}
                                    cols={88}
                                    value={this.state.Comment}
                                  />
                                ) : (
                                  <textarea
                                    className="textarea-css form-attribute"
                                    style={{
                                      maxWidth: "100%",
                                      border: "1px solid lightgrey",
                                      ...this.state.selectStyle.comment,
                                    }}
                                    placeholder="Please provide your comments regarding the cancellation request."
                                    onChange={this.handleCommentChange}
                                    rows={3}
                                    cols={88}
                                  />
                                )}
                              </div>
                            </div>
                          </div>
                        </div>
                      </>
                    ) : (
                      <>
                        <div
                          id="Approval Status"
                          className="u-border-1 u-border-palette-5-base u-container-style u-expanded-width u-group u-radius-6 u-shape-round u-group-7"
                        >
                          <div className="u-container-layout u-container-layout-7">
                            <p
                              className="u-align-left u-text u-text-2"
                              style={{ marginBottom: 10 }}
                            >
                              Approval details
                            </p>
                            <div className="row">
                              <div className="col-md-2">
                                <label
                                  style={{
                                    verticalAlign: "bottom",
                                    marginBottom: -5,
                                  }}
                                >
                                  <span style={{ color: "red" }}>*</span>{" "}
                                  Approval Status
                                </label>{" "}
                              </div>
                              <div className="col-md-2">
                                <Select
                                  value={this.state.workFlowStatusSelectedOption}
                                  isSearchable={false}
                                  options={this.renderStatusOptions()}
                                  styles={this.state.selectStyle.workFlowStatusSelectedOption}
                                  placeholder="Choose Status"
                                  onChange={this.handleAccountNameChange}
                                />
                              </div>
                            </div>
                            <div
                              className="col-md-9"
                              style={{ marginBottom: 5, width: "100%" }}
                            />
                            <div className="row">
                              <div className="col-md-7">
                                <div className="row">
                                  <div className="col-md-11">
                                    <p className="u-align-left u-text u-text-custom-color-4 u-text-25">
                                      <span className="u-text-black form-attribute">
                                        <span style={{ color: "red" }}>*</span>
                                        &nbsp;Comments&nbsp;
                                        <span
                                          style={{
                                            fontWeight: "normal",
                                            fontSize: 12,
                                            fontStyle: "italic",
                                            color: "grey",
                                          }}
                                        >
                                          (max. 500 chars)
                                        </span>
                                      </span>
                                    </p>
                                  </div>
                                  <div
                                    className="col-md-1"
                                    style={{
                                      display: "flex",
                                      justifyContent: "center",
                                      alignItems: "center",
                                    }}
                                  >
                                    <img
                                      onClick={(e) =>
                                        this.toggleTranscriptFunction(2)
                                      }
                                      src={require("../assets/images/voice.png")}
                                      className="w100"
                                      alt=""
                                      style={{
                                        width: "24px",
                                        cursor: "pointer",
                                      }}
                                    />
                                  </div>
                                </div>
                              </div>
                            </div>
                            <div className="row">
                              <div className="col-md-12">
                                <textarea
                                  className="textarea-css form-attribute"
                                  style={{
                                    maxWidth: "100%",
                                    border: "1px solid lightgrey",
                                    ...this.state.selectStyle.comment,
                                  }}
                                  rows={3}
                                  cols={88}
                                  placeholder="Please provide your comments in support of the Approval decision."
                                  onChange={this.handleCommentChange}
                                  value={this.state.Comment}
                                />
                              </div>
                            </div>
                          </div>
                        </div>
                      </>
                    )}
                    {this.state.showAdditionalDetails && (
                      <div
                        style={{
                          borderBottom: "1px solid lightgrey",
                          marginBottom: 15,
                          marginTop: 15,
                        }}
                      />
                    )}
                    {this.state.showAdditionalDetails && (
                      <div
                        id="Potential Impact"
                        className="u-border-1 u-border-palette-5-base u-container-style u-expanded-width u-group u-radius-6 u-shape-round u-group-7"
                      >
                        <div className="u-container-layout u-container-layout-7" style={{ display: "flex" }}>
                          <div className="u-container-style u-group u-shape-rectangle u-group-8">
                            <div className="u-container-layout u-container-layout-8">
                              <p
                                id="Potential Impact"
                                className="u-align-left u-text u-text-2"
                                style={{ marginBottom: 10 }}
                              >
                                Additional details
                              </p>
                              <div className="row d_flex_align_items_center">
                                <div className="col-md-6">
                                  <label
                                    style={{
                                      verticalAlign: "bottom",
                                      marginBottom: -5,
                                    }}
                                  >
                                    <span style={{ color: "red" }}>*</span> LDT
                                    Lead Name
                                  </label>{" "}
                                </div>
                                <div className="col-md-6">
                                  <Select
                                    isSearchable={false}
                                    value={this.state.LDTLeadSelectedOption}
                                    options={this.renderLeadOptions()}
                                    styles={this.state.selectStyle.LDTLeadSelectedOption}
                                    placeholder="Choose LDT Lead"
                                    onChange={this.handleLDTLeadOptionChange}
                                  />
                                </div>
                              </div>
                              <div style={{ marginBottom: 10 }} />


                              {this.state.campaignSelectedOption?.label ===
                                AIFIRST ? (
                                <>
                                  <div style={{ marginBottom: 10 }} />
                                  <div className="row d_flex_align_items_center">
                                    <div className="col-md-6">
                                      <label
                                        style={{
                                          verticalAlign: "bottom",
                                          marginBottom: -5,
                                        }}
                                      >
                                        <span style={{ color: "red" }}>*</span>{" "}
                                        Is the solution feasible ?
                                      </label>
                                    </div>
                                    <div className="col-md-6">
                                      <Select
                                        isSearchable={false}
                                        options={
                                          YESORNO
                                        }
                                        value={
                                          this.state.solutionFeasibleSelectedOption
                                        }
                                        styles={
                                          this.state.selectStyle
                                            .solutionFeasibleSelectedOption
                                        }
                                        onChange={(e) =>
                                          this.handleSolutionFeasibleChange(e)
                                        }
                                        placeholder="Please Choose"
                                      />
                                    </div>
                                  </div>

                                  <div style={{ marginBottom: 10 }} />
                                  <div className="row d_flex_align_items_center">
                                    <div className="col-md-6">
                                      <label
                                        style={{
                                          verticalAlign: "bottom",
                                          marginBottom: -5,
                                        }}
                                      >
                                        <span style={{ color: "red" }}>*</span>{" "}
                                        Solution Complexity
                                      </label>
                                    </div>
                                    <div className="col-md-6">
                                      <Select
                                        isSearchable={false}
                                        options={
                                          SOLUTIONCOMPLEXITY
                                        }
                                        value={
                                          this.state.solutionComplexitySelectedOption
                                        }
                                        styles={
                                          this.state.selectStyle
                                            .solutionComplexitySelectedOption
                                        }
                                        onChange={(e) =>
                                          this.handleSolutionComplexityChange(e)
                                        }
                                        placeholder="Please Choose"
                                      />
                                    </div>
                                  </div>

                                  <div style={{ marginBottom: 10 }} />
                                  <div className="row d_flex_align_items_center">
                                    <div className="col-md-6">
                                      <label
                                        style={{
                                          verticalAlign: "bottom",
                                          marginBottom: -5,
                                        }}
                                      >
                                        <span style={{ color: "red" }}>*</span>{" "}
                                        Is the Idea replicable
                                      </label>
                                    </div>
                                    <div className="col-md-6">
                                      <Select
                                        isSearchable={false}
                                        options={
                                          YESORNO
                                        }
                                        value={
                                          this.state.IsIdeaReplicableSelectedOption
                                        }
                                        styles={
                                          this.state.selectStyle
                                            .IsIdeaReplicableSelectedOption
                                        }
                                        onChange={(e) =>
                                          this.handleIsIdeaReplicableChange(e)
                                        }
                                        placeholder="Choose replicability Index"
                                      />
                                    </div>
                                  </div>
                                  <div style={{ marginBottom: 10 }} />
                                </>
                              ) : null}




                              <div
                                style={{ marginTop: 10, marginBottom: 14 }}
                              />



                              {this.state.ideaItem.NewOrReplicatedIdea && (
                                <div className="row">
                                  <div className="col-md-10">
                                    <label
                                      style={{
                                        verticalAlign: "bottom",
                                        marginBottom: -5,
                                      }}
                                    >
                                      <span style={{ color: "red" }}>*</span>{" "}
                                      Have you verified the replication id and
                                      confirm this to be replication project?
                                    </label>
                                  </div>
                                  <div className="col-md-2">
                                    <label className="switch">
                                      <input
                                        type="checkbox"
                                        checked={
                                          this.state.ideaItem
                                            .IsReplicationVerified === null
                                            ? false
                                            : this.state.ideaItem
                                              .IsReplicationVerified
                                        }
                                        onChange={() =>
                                          this.showHideVerifyReplicationDiv()
                                        }
                                      />
                                      <span className="slider round" />
                                    </label>
                                  </div>
                                </div>
                              )}
                            </div>
                          </div>

                          <p className="visible-md-block visible-sm-block visible-xs-block" style={{ marginTop: 45 }}>&nbsp;</p>



                          <div className="u-container-style u-group u-shape-rectangle u-group-9" style={{ marginTop: "-10px" }}>
                            <div className="u-container-layout u-container-layout-9" >
                              <div className="row d_flex_align_items_center" style={{ marginBottom: 10 }}>
                                <div className="col-md-5">
                                  <label style={{ verticalAlign: "bottom", marginBottom: -5, }}>
                                    <span style={{ color: "red" }}>*</span>{" "}
                                    Certification Level
                                  </label>
                                </div>
                                <div className="col-md-7">
                                  <Select
                                    isSearchable={false}
                                    options={this.renderCertLevelsOptions()}
                                    styles={this.state.selectStyle.certLevelsSelectedOption}
                                    value={this.state.certLevelsSelectedOption}
                                    onChange={this.handleCertLevelChange}
                                    placeholder="Choose Certification Level"
                                  />
                                </div>
                              </div>

                              <div className="row d_flex_align_items_center" style={{ marginBottom: 10 }}>
                                <div className="col-md-5">
                                  <label style={{ verticalAlign: "bottom", marginBottom: -5, }}>
                                    <span style={{ color: "red" }}>*</span>{" "}
                                    Transformation Lever
                                  </label>
                                </div>
                                <div className="col-md-7">
                                  <Select
                                    className="transformation_lever_disabled"
                                    options={this.renderTransLeversOptions()}
                                    value={this.state.transSelectedOption}
                                    styles={this.state.selectStyle.transSelectedOption}
                                    onChange={this.handleTransLeversChange}
                                    placeholder="Choose Transformation Lever"
                                  />
                                </div>
                              </div>


                              {this.state.digitalProjectEnabled ? (
                                <div className="row d_flex_align_items_center" style={{ marginBottom: "10px" }}>
                                  <div className="col-md-5">
                                    <label style={{ verticalAlign: "bottom", marginBottom: -5, }}>
                                      <span style={{ color: "red" }}>*</span>{" "}
                                      Digital Project Type
                                    </label>
                                  </div>
                                  <div className="col-md-7" >
                                    <Select
                                      isSearchable={false}
                                      options={this.renderDigitalProjectTypeOptions()}
                                      styles={this.state.selectStyle.digitalProjectTypeSelectedOptions}
                                      value={this.state.digitalProjectTypeSelectedOptions}
                                      onChange={this.handleDigitalProjectTypeChange}
                                      placeholder="Choose Project Type"
                                    />
                                  </div>
                                </div>
                              ) : null}

                              {
                                this.state.workTypeEnabled
                                  ?
                                  <div className="row d_flex_align_items_center" style={{ marginBottom: 10 }}>
                                    <div className="col-md-5" >
                                      <label style={{ verticalAlign: "bottom", marginBottom: -5}}>
                                        <span style={{ color: "red" }}>*</span>{" "}
                                        Work Type
                                      </label>
                                    </div>
                                    <div className="col-md-7" >
                                      <Select
                                        isSearchable={false}
                                        isDisabled={this.state.campaignSelectedOption?.label === "Data Bridge" ? true : false}
                                        options={this.renderCertWorkTypeOptions(this.state.certLevelsSelectedOption)}
                                        styles={this.state.selectStyle.certWorkTypeSelectedOption}
                                        value={this.state.certWorkTypeSelectedOption}
                                        onChange={this.handleCertWorkTypeChange}
                                        placeholder="Choose Work Type"
                                      />
                                    </div>
                                  </div>
                                  :
                                  null

                              }

                              {
                                this.state.displayWorkType
                                  ?
                                  <>
                                    <div className="row d_flex_align_items_center" style={{ marginBottom: 10 }}>
                                      <div className="col-md-5" style={{ marginBottom: 5 }}>
                                        <label style={{ verticalAlign: "bottom", marginBottom: -5, }}>
                                          <span style={{ color: "red" }}>&nbsp;</span>{" "}
                                          Work Type
                                        </label>
                                      </div>
                                      <div className="col-md-7">
                                        <input
                                          className="form-input"
                                          disabled
                                          type="text"
                                          value={this.state.certWorkTypeSelectedOption ? this.state.certWorkTypeSelectedOption.label : ""}
                                          style={{ fontStyle: "normal" }}
                                        />
                                      </div>
                                    </div>
                                  </>
                                  :
                                  null
                              }

                              <div className="row d_flex_align_items_center" style={{ marginBottom: 10 }}>
                                <div className="col-md-5">
                                  <label style={{ verticalAlign: "bottom", marginBottom: -5, }}>
                                    <span style={{ color: "red" }}>*</span>{" "}
                                    AI Classification
                                  </label>
                                </div>
                                <div className="col-md-7">
                                  <Select
                                    isSearchable={false}
                                    options={this.renderAIClassificationList()}
                                    value={this.state.aiClassificationListSelectedOption}
                                    styles={this.state.selectStyle.aiClassificationListSelectedOption}
                                    onChange={(e) => this.handleAIClassificationList(e)}
                                    placeholder="Choose AI Classification"
                                  />
                                </div>
                              </div>
                              <div className="row d_flex_align_items_center" style={{ marginBottom: 10 }}>
                                <div className="col-md-5">
                                  <label style={{ verticalAlign: "bottom", marginBottom: -5, }}>
                                    <span style={{ color: "red" }}>*</span>{" "}
                                    Tools/Methodology Used
                                  </label>
                                </div>
                                <div className="col-md-7">
                                  <Select
                                    isSearchable={true}
                                    isMulti={true}
                                    options={this.renderMethodologyOptions()}
                                    value={this.state.methodologySelectedOptions}
                                    styles={this.state.selectStyle.methodologySelectedOptions}
                                    onChange={this.handleMethodologyChange}
                                    placeholder="Choose Methodology"
                                    maxMenuHeight={160}
                                  />
                                </div>
                              </div>
                              <div className="row d_flex_align_items_center" style={{ marginBottom: 10 }}>
                                <div className="col-md-5">
                                  <p className="u-align-left u-text u-text-custom-color-4 u-text-8">
                                    <span className="u-text-black form-attribute" style={{ fontWeight: 'normal' }}><span style={{ color: 'red' }}>&nbsp;</span> Other tools <span style={{ fontWeight: 'normal', fontSize: 12, fontStyle: 'italic', color: 'grey' }}>(max. 300 chars)</span></span>
                                  </p>
                                </div>
                                <div className="col-md-7">
                                  <textarea
                                    className="textarea-css form-attribute"
                                    style={{ border: "1px solid lightgrey", ...this.state.selectStyle.OtherTools, width: "100%" }}
                                    placeholder='Provide other tools'
                                    value={this.state.OtherTools}
                                    type="text"
                                    title={this.state.OtherTools ? this.state.OtherTools : ""}
                                    onChange={(e) => this.handleOtherToolsChange(e.target.value)}
                                  />
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    )}

                    {this.state.workFlowStatusSelectedOption && this.state.workFlowStatusSelectedOption.label === "Approve" ? (
                      <>
                        {this.state.certLevelsSelectedOption && this.state.certLevelsSelectedOption.label === "Lean" && this.state.businessImpactMasterList ? (
                          <>
                            <div className="" style={{ borderBottom: "1px solid lightgray", marginBottom: "30px", }}></div>
                            <ValueDelivery
                              IdeaData = {this.state.ideaItem}
                              vdForComponent={this.state.vdForComponent}
                              BIMasterDataVerseNew={this.state.businessImpactMasterList}
                              func={this.pull_data}
                              viewIdea={false}
                              vdType={this.handleVDTypeChange}
                              IdeaId={this.state.ideaItem.IdeaId}
                              fetchMonetizationFileDetails={this.pull_file_data}
                              fetchMonetizationFpnaOhr={
                                this.pull_monetization_fpna_ohr
                              }
                              fetchMonetizationFpnaName={
                                this.pull_monetization_fpna_name
                              }
                              fetchMonetizationSowID={
                                this.pull_monetization_sowId
                              }
                              bbMonetizationTotal={this.pull_monetizedTotal}
                              monetizableProject={this.pull_monetizableProject}
                              monetizableStatus={this.pull_monetizableStatus}
                              fetchFPAOHRforIncreaseInRevenue={
                                this.fetchFPAOHRforIncreaseInRevenue
                              }
                              bbMonetizationApproval={false}
                              postFpnaValid={false}
                              fetchDeletedBIRows={
                                this.remove_bi_data_after_delete
                              }
                              fetchMonetizationGOLName={
                                this.pullMonetizationGOLName
                              }
                              fetchMonetizationGOLOhr={
                                this.pullMonetizationGOLOhr
                              }
                              fetchCategoryNotListed={this.pullCategoryNotListed}

                              fetchPPTDeck={this.pullPPTDeck}
                              fetchClientDocName={this.pullClientDocName}
                              fetchClientDocType={this.pullClientDocType}
                              fetchClientDocContent={this.pullClientDocContent}
                              fetchGolDocName={this.pullgolFileName}
                              fetchGolDocType={this.pullgolFileType}
                              fetchGolDocContent={this.pullgolContent}
                              fetchfpnaDocName={this.pullfpnafileName}
                              fetchfpnaDocType={this.pullfpnafileType}
                              fetchfpnaDocContent={this.pullfpnafileContent}
                              fetchClientName={this.pullClientName}
                              fetchClientRole={this.pullClientRole}
                              fetchClientSignOffDate={this.pullClientSignOff}
                              fetchFpnaName={this.pullFpnaName}
                              fetchGolName={this.pullGolName}
                              fetchFpnaOhr={this.pullFpnaOhr}
                              fetchGolOhr={this.pullGolOhr}
                              fetchFileDetails={this.pull_fileDetails}

                              
                            />
                          </>
                        ) : null}
                      </>
                    ) : null}



                    {this.state.showHrefModal ? (
                      <>
                        <div className="custom_modal href_modal">
                          <div className="modal_body href_modal_body">
                            <div className="href_modal_dialog">
                              <p>
                                To add a new category please raise a Helpmate
                                ticket, Click here to View SOP
                              </p>
                              <div className="href_modal_body_buttons">
                                <div className="btn-group href_modal_body_buttons">
                                  <button className="u-active-custom-color-6 u-border-2 u-border-active-black u-border-hover-black u-border-white u-btn u-btn-round u-button-style u-custom-color-3 u-hover-custom-color-6 u-radius-6 u-btn-3">
                                    <a
                                      href="https://genpactonline.sharepoint.com/:b:/r/sites/LeanDigitalTransformation/Documents/KM%20Page%20-%202021/Certification%20Guidelines,%20SOPs%20%26%20Handbooks/Certification%20guidelines,%20SOPs%20%26%20Handbooks/Systems%20%26%20Tools/Helpmate-Data%20Related%20Request/ProGEAR%20Value%20Delivery%20Category%20Addition%20SOP.pdf?csf=1&web=1&e=5kKbFg"
                                      style={{ color: "#FFF" }}
                                      target="_blank"
                                    >
                                      Click Here
                                    </a>
                                  </button>
                                  <button
                                    className="u-border-2 u-border-active-black u-border-blue u-btn-cancel u-btn-round u-button-style u-radius-6"
                                    onClick={(e) =>
                                      this.setState({ showHrefModal: false })
                                    }
                                  >
                                    Cancel
                                  </button>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </>
                    ) : null}






                    {
                      this.state.impactOptionSelected && this.state.impactOptionSelected.label === NO_VD
                        && this.state.ideaItem.WorkflowStatus === "Pending"
                        ?
                        <>

                        </>

                        :
                        <div
                          className=""
                          style={{
                            borderTop: "1px solid lightgray",
                            margin: "20px 0px",
                          }}
                        ></div>
                    }


                    <div className="btn-group" style={{ marginTop: 15 }}>
                      <button
                        className="u-active-custom-color-6 u-border-2 u-border-active-black u-border-hover-black u-border-white u-btn u-btn-round u-button-style u-custom-color-3 u-hover-custom-color-6 u-radius-6 u-btn-3"
                        onClick={this.submitIdea}
                      >
                        Save
                      </button>
                      <button
                        className="u-border-2 u-border-active-black u-border-blue u-btn-cancel u-btn-round u-button-style u-radius-6"
                        onClick={this.cancelEvent}
                      >
                        Cancel
                      </button>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>
      </>
    );
  }
}

export default ReviewIdeaPage;
